import {
  Convenio,
  ProdutoSimulacao,
  Telefone,
  Perfil,
  Profissao,
  ResponseWithMessages,
  ReqFgts,
  ReqCrmSimulacao,
  ListaParcelasEValorTotalSimulacao,
  SimulacaoCrefaz,
  ListaValoresLiberado
} from 'models/types'
import { SagaIterator } from 'redux-saga'
import {
  call,
  fork,
  put,
  all,
  takeEvery,
  select,
  CallEffect,
  delay,
  AllEffect,
  takeLatest,
  take
} from 'redux-saga/effects'
import { ApplicationState } from 'store'
import { ATENDIMENTO, TYPES } from './types'
import {
  Agendamento,
  Anexo,
  Beneficio,
  DadosBancarios,
  InfosConsig,
  InfosMatriculaLead,
  MatriculaResumo,
  ParametroIntegracao,
  ReferenciaInvalid,
  ResponseTabulacao,
  StatusChamadaEnum
} from 'models/atendimento/types'
import { handlerError } from 'util/handlerError'
import { toast } from 'react-toastify'
import {
  maskCEP,
  maskCPF,
  maskDate,
  maskMoney,
  maskNumber,
  maskPhoneWithDDD,
  removeMaskCEP,
  removeMaskCPF,
  removeMaskMoney,
  removeMaskPhone
} from 'util/masks'
import {
  CadastroSimplificadoReq,
  Contratos,
  InfoCliente,
  InfosChamada,
  InfosClienteResumo,
  ProdutosContratados,
  TabulacaoAtendimento
} from 'models/atendimento/types'
import * as atendimentoController from 'controller/atendimentoController'
import * as atendimentoActions from 'store/modules/atendimento/actions'
import * as inicioActions from 'store/modules/inicio/actions'
import * as loadingActions from 'store/modules/loading/actions'
import * as navbarActions from 'store/modules/navbar/actions'
import * as loginActions from 'store/modules/login/actions'
import moment from 'moment'
import history from 'util/history'
import { handlerErrorFgts } from 'util/handlerErrorFgts'
import { AxiosResponse } from 'axios'
import { ReqCrm } from 'models/types'
import { handlerErrorSimulacao } from 'util/handlerErroSimulacao'
import { generateGuid } from 'util/generateGuid'
import { filterReferenciasPreenchidas } from 'util/filterReferencias'
import {
  clearNotifications,
  handlerErrorSimulationService
} from 'util/handleErrorSimulacaoService'
import { InfosCrefazContratacao } from 'controller/atendimentoController'
import { NAVBAR } from '../navbar/types'

interface GenericProps {
  type: string
  cpf: string
  index: number
}

function* getFormularioAtendimento30({ cpf }: GenericProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    yield put(atendimentoActions.setInfosFormulario(cpf, 'cpf'))
    const cpfFormated = removeMaskCPF(cpf)
    yield call(atendimentoController.getFormularioAtendimento30, cpfFormated)
    // if (!response?.data?.content) {
    //   yield put(atendimentoActions.toggleFormularioNecessidade(true))
    // } else {
    // Propriedades type e index opcionais foram adicionadas para manter compatibilidade com chamadas anteriores
    yield call(getAtendimentos, { cpf: cpfFormated, type: '', index: 0 })
    // }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.message === 'Pessoa não encontrada.') {
      yield put(atendimentoActions.toggleConfirmacaoCadastro(true))
      yield put(atendimentoActions.cleanInfosCadastroClienteModal())
    } else {
      handlerError(error, 'Não foi possível iniciar o atendimento!')
    }
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* salvarFormularioAtendimento30({ cpf }: GenericProps): SagaIterator {
  const { formularioNecessidade }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(
      atendimentoController.salvarFormularioAtendimento30,
      formularioNecessidade.answers
    )
    yield put(atendimentoActions.toggleFormularioNecessidade(false))
    yield call(getAtendimentos, {
      cpf,
      indexTabCliente: formularioNecessidade.answers.indexTabCliente,
      type: '',
      index: 0
    })
    yield put(atendimentoActions.cleanInfosFormulario())
    toast.success('Formulário salvo com sucesso!')
  } catch (error) {
    handlerError(error, 'Não foi possível salvar o formulário!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface GetAtendimentosProps extends GenericProps {
  indexTabCliente?: number
}

function* getAtendimentos({
  cpf,
  indexTabCliente = 2
}: GetAtendimentosProps): SagaIterator {
  try {
    yield put(atendimentoActions.setLoadingStartAtendimento(true))
    const cpfFormated = removeMaskCPF(cpf)

    if (cpfFormated.length !== 11) {
      return toast.warn('Digite um CPF válido para iniciar um atendimento')
    }
    const response = yield call(
      atendimentoController.iniciarAtendimento,
      cpfFormated
    )
    if (response?.data?.content?.atendimentoDiscadorAtivo) {
      return yield put(loginActions.verificaAtendimentoAtivoSaga())
    }
    yield put(atendimentoActions.cleanCpfAtendimento())
    yield put(atendimentoActions.startAtendimento(cpfFormated, indexTabCliente))
    const telefones: InfosChamada['telefones'] = []
    response?.data?.content?.telefones.forEach((telefone: Telefone) => {
      telefones.push({
        numero: `(${telefone.ddd}) ${telefone.numero}`,
        whatsapp: telefone.whatsapp,
        telefoneId: telefone.telefoneId
      })
    })

    yield put(
      atendimentoActions.setInfosContato(
        {
          nome: response?.data?.content?.nome,
          dataNascimento: moment(
            response?.data?.content?.dataNascimento
          ).format('DD/MM/YYYY'),
          cidade: response?.data?.content?.cidade,
          sexo: response?.data?.content?.sexo,
          clienteRiber: response?.data?.content?.clienteRiber,
          infosChamada: {
            telefones: telefones,
            dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
            duracaoChamada: '00:00',
            horarioAgendamento: moment().format('HH:mm'),
            numeroChamada: [],
            observacoesAgendamento: '',
            tabulacaoChamada: null,
            tipoAgendamento: '',
            emChamada: false,
            infosMatriculasLead: []
          },
          atendimentoId: response?.data?.content?.atendimentoId,
          tipoProduto: response?.data?.content?.tipoProduto,
          campanhaCrmId: response?.data?.content?.campanhaCrmId,
          atendimentoAgendadoId: response?.data?.content?.atendimentoAgendadoId,
          tipoAtendimento: 0,
          integracaoUrl: '',
          clienteSite: response?.data?.content?.clienteSite
        },
        cpfFormated
      )
    )

    yield put(
      atendimentoActions.setModalAtendimentoAgendado(
        !!response?.data?.content?.atendimentoAgendadoId,
        cpfFormated
      )
    )
    if (window.location.pathname.toLowerCase() !== '/atendimento') {
      history.push('/atendimento')
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.message === 'Pessoa/Cliente não encontrado') {
      yield put(atendimentoActions.toggleConfirmacaoCadastro(true))
      yield put(atendimentoActions.cleanInfosCadastroClienteModal())
    } else {
      handlerError(error, 'Não foi possível iniciar um atendimento')
    }
  } finally {
    yield put(atendimentoActions.setLoadingStartAtendimento(false))
  }
}

function* finalizaAgendamento({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(atendimentoController.finalizaAgendamento, {
      atendimentoAgendadoId:
        atendimentosAbertos[index].tabContato.atendimentoAgendadoId ?? '',
      atendimentoId: atendimentosAbertos[index].tabContato.atendimentoId
    })
    yield put(
      atendimentoActions.setModalAtendimentoAgendado(
        false,
        atendimentosAbertos[index].cpf
      )
    )
    toast.success('Atendimento agendado realizado com sucesso!')
  } catch (error) {
    handlerError(error, 'Não foi possível confirmar o atendimento agendado!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface EnriquecerDadosProps extends GenericProps {
  automatico?: boolean
}

function* enriquecerDados({
  cpf,
  index,
  automatico
}: EnriquecerDadosProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(atendimentoController.getTelefones, cpf)
    if ((response?.data?.content?.length <= 0 && automatico) || !automatico) {
      const responseEnriquecimento = yield call(
        atendimentoController.enriquecerDados,
        cpf
      )
      const telefones: InfosChamada['telefones'] = []
      responseEnriquecimento?.data?.content?.forEach((telefone: Telefone) => {
        telefones.push({
          numero: `(${telefone.ddd}) ${telefone.numero}`,
          whatsapp: telefone.whatsapp,
          telefoneId: telefone.telefoneId
        })
      })
      yield put(
        atendimentoActions.setInfosContato(
          {
            ...atendimentosAbertos[index].tabContato,
            infosChamada: {
              ...atendimentosAbertos[index].tabContato.infosChamada,
              telefones: telefones
            }
          },
          removeMaskCPF(cpf)
        )
      )
      toast.success('Enriquecimento efetuado com sucesso!')
      yield put(atendimentoActions.getInformacoesClienteSaga(cpf, index))
    }
    if (response?.data?.content?.length > 0 && automatico) {
      yield put(atendimentoActions.validarNovoAtendimentoSaga(cpf, index))
      yield take(TYPES.VALIDAR_NOVO_ATENDIMENTO_SUCCESS)
    }
  } catch (error) {
    handlerErrorSimulacao(error, 'Não foi possível enriquecer os dados!')
    yield put(atendimentoActions.validarNovoAtendimentoSaga(cpf, index))
    yield take(TYPES.VALIDAR_NOVO_ATENDIMENTO_SUCCESS)
  } finally {
    yield put(atendimentoActions.setEnriquecido(index))
    yield put(loadingActions.setLoading(false))
  }
}

function* validarNovoAtendimento({ cpf, index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const novoAtendimento =
      !!atendimentosAbertos[index].tabContato.campanhaCrmId ||
      (!!atendimentosAbertos[index].tabContato.consultorId &&
        !!atendimentosAbertos[index].tabContato.tipoProduto) ||
      atendimentosAbertos[index].tabContato.tipoAtendimento === 3

    const response = yield call(atendimentoController.validarNovoAtendimento, {
      cpf: cpf,
      campanhaCrmId: atendimentosAbertos[index].tabContato.campanhaCrmId,
      consultorCarteiraId: atendimentosAbertos[index].tabContato.consultorId,
      novoAtendimento: novoAtendimento,
      tipoAtendimento: atendimentosAbertos[index].tabContato.tipoAtendimento,
      tipoProdutoEnum: atendimentosAbertos[index].tabContato.tipoProduto
    })
    if (response?.data?.content) {
      yield put(atendimentoActions.endAtendimento(index))
      yield put(
        atendimentoActions.startAtendimento(
          response?.data?.content?.atendimento.cpfCnpj,
          1
        )
      )
      const telefones: InfosChamada['telefones'] = []
      response?.data?.content?.atendimento.telefones?.forEach(
        (telefone: Telefone) => {
          telefones.push({
            numero: `(${telefone.ddd}) ${telefone.numero}`,
            whatsapp: telefone.whatsapp,
            telefoneId: telefone.telefoneId
          })
        }
      )
      yield put(
        atendimentoActions.setInfosContato(
          {
            nome: response?.data?.content?.atendimento.nome,
            dataNascimento: moment(
              response?.data?.content?.atendimento.dataNascimento
            ).format('DD/MM/YYYY'),
            cidade: response?.data?.content?.atendimento.cidade,
            sexo: response?.data?.content?.atendimento.sexo,
            clienteRiber: response?.data?.content?.atendimento.clienteRiber,
            infosChamada: {
              telefones: telefones,
              dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
              horarioAgendamento: moment().format('HH:mm'),
              numeroChamada: [],
              observacoesAgendamento: '',
              tabulacaoChamada: null,
              tipoAgendamento: '',
              emChamada: false,
              infosMatriculasLead: []
            },
            atendimentoId: response?.data?.content?.atendimento.atendimentoId,
            tipoProduto: response?.data?.content?.atendimento.tipoProduto,
            campanhaCrmId: response?.data?.content?.atendimento.campanhaCrmId,
            atendimentoAgendadoId:
              response?.data?.content?.atendimento.atendimentoAgendadoId,
            consultorId: atendimentosAbertos[index].tabContato.consultorId,
            tipoAtendimento:
              atendimentosAbertos[index].tabContato.tipoAtendimento,
            integracaoUrl: ''
          },
          response?.data?.content?.atendimento.cpfCnpj
        )
      )
      yield put(
        atendimentoActions.setModalAtendimentoAgendado(
          !!response?.data?.content?.atendimentoAgendadoId,
          removeMaskCPF(response?.data?.content?.cpfCnpj)
        )
      )
    }
  } catch (error) {
    handlerError(error, 'Não foi possível pular para o próximo atendimento')
  } finally {
    yield put({
      type: TYPES.VALIDAR_NOVO_ATENDIMENTO_SUCCESS
    })
    yield put(loadingActions.setLoading(false))
  }
}

function* getConvenios(): SagaIterator {
  try {
    const response = yield call(atendimentoController.getConvenios)
    const convenios: Convenio[] = []
    response?.data?.content?.map((convenio: Convenio) => {
      convenios.push({
        codigoEntidade: convenio.codigoEntidade,
        sequencialOrgao: convenio.sequencialOrgao,
        codigoExibicao: convenio.codigoExibicao,
        descricao: convenio.descricao,
        clientes: convenio.clientes,
        parametrizacaoProdutos: convenio.parametrizacaoProdutos,
        id: convenio.id,
        ativo: convenio.ativo,
        usuario: convenio.usuario,
        idUsuarioCriacao: convenio.idUsuarioCriacao,
        dataCriacao: convenio.dataCriacao,
        usuarioAlteracao: convenio.idUsuarioCriacao,
        idUsuarioUltimaAlteracao: convenio.idUsuarioUltimaAlteracao,
        dataUltimaAlteracao: convenio.dataUltimaAlteracao
      })
    })
    yield put(atendimentoActions.setConveniosModal(convenios))
  } catch (error) {
    //
  }
}

function* getConveniosInfo({ index }: GenericProps): SagaIterator {
  try {
    const response = yield call(atendimentoController.getConvenios)
    const convenios: Convenio[] = []
    response?.data?.content?.map((convenio: Convenio) => {
      convenios.push({
        codigoEntidade: convenio.codigoEntidade,
        sequencialOrgao: convenio.sequencialOrgao,
        codigoExibicao: convenio.codigoExibicao,
        descricao: convenio.descricao,
        clientes: convenio.clientes,
        parametrizacaoProdutos: convenio.parametrizacaoProdutos,
        id: convenio.id,
        ativo: convenio.ativo,
        usuario: convenio.usuario,
        idUsuarioCriacao: convenio.idUsuarioCriacao,
        dataCriacao: convenio.dataCriacao,
        usuarioAlteracao: convenio.idUsuarioCriacao,
        idUsuarioUltimaAlteracao: convenio.idUsuarioUltimaAlteracao,
        dataUltimaAlteracao: convenio.dataUltimaAlteracao
      })
    })
    yield put(
      atendimentoActions.setOptionsSelectsMatriculas(
        convenios,
        'convenios',
        index
      )
    )
  } catch (error) {
    //
  }
}

function* getPerfis(): SagaIterator {
  try {
    const response = yield call(atendimentoController.getPerfis)
    const perfis: Perfil[] = []
    response?.data?.content?.map((perfil: Perfil) => {
      perfis.push({
        id: perfil.id,
        descricao: perfil.descricao,
        tipoPerfil: perfil.tipoPerfil
      })
    })
    yield put(atendimentoActions.setPerfisModal(perfis))
  } catch (error) {
    //
  }
}

function* getProfissoes({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.profissoes
        .length === 0
    ) {
      const response = yield call(atendimentoController.getProfissoes)
      const profissoes: Profissao[] = []
      response.data?.content?.map((profissao: Profissao) => {
        profissoes.push({
          id: profissao.id,
          titulo: profissao.titulo
        })
      })
      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          profissoes,
          'profissoes',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* salvarCadastroSimplificado(): SagaIterator {
  const { modalCadastroCliente }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const infosCliente: CadastroSimplificadoReq = {
      convenioId: modalCadastroCliente.convenioId,
      nome: modalCadastroCliente.nome,
      cpf: removeMaskCPF(modalCadastroCliente.cpf),
      dataNascimento: modalCadastroCliente.dataNascimento,
      matricula: modalCadastroCliente.matricula,
      ddd: modalCadastroCliente.ddd,
      telefone: modalCadastroCliente.telefone,
      perfilId: modalCadastroCliente.perfilId || '',
      margem: Number(removeMaskMoney(modalCadastroCliente.margem)),
      margemCartao: Number(removeMaskMoney(modalCadastroCliente.margemCartao)),
      numeroNit: Number(modalCadastroCliente.numeroNit)
    }
    const response = yield call(
      atendimentoController.salvarCadastroSimplificado,
      infosCliente
    )
    yield put(atendimentoActions.toggleCadastroSimplificado(false))
    yield put(atendimentoActions.cleanInfosCadastroClienteModal())
    yield put(atendimentoActions.setInfosFormulario(2, 'indexTabCliente'))
    yield put(
      atendimentoActions.getFormularioAtendimento30Saga(
        maskCPF(response?.data?.content?.cpfCnpj)
      )
    )
    toast.success('Cliente cadastrado com sucesso!')
  } catch (error) {
    handlerError(error, 'Não possível realizar o cadastro!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getPerfilCliente({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(atendimentoActions.setInfosProduto([], 'beneficios', index))
    const response = yield call(
      atendimentoController.getPerfilCliente,
      atendimentosAbertos[index].cpf
    )
    const perfis: Beneficio[] = []
    response?.data?.content?.map((perfil: Beneficio) => {
      perfis.push({
        id: perfil.id,
        clientePerfil: {
          id: perfil.clientePerfil.id,
          descricao: perfil.clientePerfil.descricao,
          tipoPerfil: perfil.clientePerfil.tipoPerfil
        },
        dataAtualizacaoToken: perfil.dataAtualizacaoToken,
        dataRespostaIn100: perfil.dataRespostaIn100,
        dataConsentimento: perfil.dataConsentimento,
        numero: perfil.numero,
        numeroNit: perfil.numeroNit,
        loading: false
      })
    })
    yield put(atendimentoActions.setInfosProduto(perfis, 'beneficios', index))
  } catch (error) {
    //
  }
}

interface DiscarClienteProps extends GenericProps {
  tipoLigacao: number
  telefoneId?: string
}

function* discarCliente({
  index,
  telefoneId
}: DiscarClienteProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(atendimentosAbertos[index].cpf)
    const response = yield call(
      atendimentoController.verificaNaoPerturbe,
      cpfFormated
    )
    if (!response?.data?.content) {
      yield call(atendimentoController.discarCliente, {
        cpf: cpfFormated,
        tipoLigacao: atendimentosAbertos[index].tabContato.tipoChamada,
        atendimentoId: atendimentosAbertos[index].tabContato.atendimentoId,
        telefoneId: telefoneId
      })
      toast.success('Ligação efetuada com sucesso!')
    } else {
      toast.error(
        `Cliente com o CPF ${maskCPF(
          atendimentosAbertos[index].cpf
        )} registrado no não perturbe`,
        {
          className: 'text-break',
          autoClose: false
        }
      )
    }
  } catch (error) {
    yield put(
      atendimentoActions.setInfosChamadaContato(false, 'emChamada', index)
    )
    yield put(
      atendimentoActions.setInfosChamadaContato('', 'numeroChamada', index)
    )
    handlerError(error, 'Não foi possível realizar a ligação!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getListaAtendimentos({ cpf, index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    const response = yield call(
      atendimentoController.getAtendimentos,
      cpf,
      atendimentosAbertos[index].tabContato.tabelaAtendimentos.page,
      atendimentosAbertos[index].tabContato.tabelaAtendimentos.pageSize
    )
    yield put(
      atendimentoActions.setPaginationAtendimentos(
        response?.data?.content?.quantidadeTotal,
        'totalRegistros',
        index
      )
    )

    yield put(
      atendimentoActions.setInfosContatoField(
        response?.data?.content?.registros.map((registro: Agendamento) => {
          return {
            ...registro,
            index
          }
        }),
        'agendamentos',
        index
      )
    )
  } catch (error) {
    //
  }
}

function* getTabulacoes({ index }: GenericProps): SagaIterator {
  try {
    const response = yield call(atendimentoController.getTabulacoes)

    yield put(
      atendimentoActions.setInfosContatoField(
        response?.data?.content,
        'tabulacoes',
        index
      )
    )

    yield put(
      atendimentoActions.setInfosContatoField(
        response?.data?.content?.registros.map((registro: Agendamento) => {
          return {
            ...registro,
            index
          }
        }),
        'agendamentos',
        index
      )
    )
  } catch (error) {
    //
  }
}

function* getTiposAgendamento({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (atendimentosAbertos[index].tabContato.tiposAgendamentos.length === 0) {
      const response = yield call(atendimentoController.getTiposAtendimento)
      yield put(
        atendimentoActions.setInfosContatoField(
          response?.data?.content,
          'tiposAgendamentos',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}
function* enviarSms({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )

  try {
    yield put(loadingActions.setLoading(true))

    const telefone = atendimentosAbertos[index].tabContato.modalSms.telefone
    const mensagem = atendimentosAbertos[index].tabContato.modalSms.mensagem
    const cpf = atendimentosAbertos[index].cpf

    yield call(atendimentoController.enviarSms, telefone, mensagem, cpf)

    toast.success('SMS enviado com sucesso!')
    yield put(
      atendimentoActions.setInfoContatoModalSmsField('', 'mensagem', index)
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
interface GetConversaSmsProps extends GenericProps {
  telefone: number
}

function* getConversaSms({
  telefone,
  index
}: GetConversaSmsProps): SagaIterator {
  try {
    yield put(
      atendimentoActions.setInfoContatoModalSmsField(true, 'loading', index)
    )

    const responseCliente = yield call(
      atendimentoController.respostaSms,
      Number(telefone)
    )

    if (responseCliente?.data?.content) {
      const replies = responseCliente.data.content.map(
        (item: { reply: string; received_at: string }) =>
          JSON.stringify({ reply: item.reply, receivedAt: item.received_at })
      )

      yield put(
        atendimentoActions.setInfoContatoModalSmsField(
          replies,
          'resposta',
          index
        )
      )
    }

    const responseRiber = yield call(
      atendimentoController.mensagensRiberSMS,
      Number(telefone)
    )
    if (responseRiber?.data?.content) {
      const responseSms = responseRiber.data.content.map(
        (item: { mensagem: string; dataCriacao: string }) =>
          JSON.stringify({
            mensagem: item.mensagem,
            dataCriacao: item.dataCriacao
          })
      )

      yield put(
        atendimentoActions.setInfoContatoModalSmsField(
          responseSms,
          'responseClient',
          index
        )
      )
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(
      atendimentoActions.setInfoContatoModalSmsField(false, 'loading', index)
    )
  }
}

function* tabularAtendimento({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  const { ramalAssociado, statusAgente }: NAVBAR = yield select(
    (state: ApplicationState) => state.navbar
  )
  try {
    yield put(loadingActions.setLoading(true))
    let tabulacao: TabulacaoAtendimento
    if (
      atendimentosAbertos[index].tabContato.infosChamada.tabulacaoChamada
        ?.personalizado
    ) {
      tabulacao = {
        atendimentoId: atendimentosAbertos[index].tabContato.atendimentoId,
        cpf: atendimentosAbertos[index].cpf,
        ddd: atendimentosAbertos[
          index
        ].tabContato.infosChamada.numeroChamada?.substring(1, 3),
        telefone: atendimentosAbertos[
          index
        ].tabContato.infosChamada.numeroChamada
          ?.substring(5)
          .replace('-', ''),
        tabulacaoId:
          atendimentosAbertos[index].tabContato.infosChamada.tabulacaoChamada
            ?.id,
        dataAtendimento:
          atendimentosAbertos[index].tabContato.infosChamada.dataAgendamento,
        horario:
          atendimentosAbertos[index].tabContato.infosChamada.horarioAgendamento,
        tipoAgendamentoId:
          atendimentosAbertos[index].tabContato.infosChamada.tipoAgendamento,
        observacoes:
          atendimentosAbertos[index].tabContato.infosChamada
            .observacoesAgendamento,
        campanhaCrmId: atendimentosAbertos[index].tabContato.campanhaCrmId,
        consultorCarteiraId: atendimentosAbertos[index].tabContato.consultorId,
        tipoAtendimento: atendimentosAbertos[index].tabContato.tipoAtendimento,
        tipoProduto: atendimentosAbertos[index].tabContato.tipoProduto,
        callId: atendimentosAbertos[index].tabContato.infosChamada.callId
      }
    } else {
      tabulacao = {
        atendimentoId: atendimentosAbertos[index].tabContato.atendimentoId,
        cpf: atendimentosAbertos[index].cpf,
        ddd: atendimentosAbertos[
          index
        ].tabContato.infosChamada.numeroChamada?.substring(1, 3),
        telefone: atendimentosAbertos[
          index
        ].tabContato.infosChamada.numeroChamada
          ?.substring(5)
          .replace('-', ''),
        tabulacaoId:
          atendimentosAbertos[index].tabContato.infosChamada.tabulacaoChamada
            ?.id,
        dataAtendimento: '',
        tipoAgendamentoId: '',
        observacoes: '',
        campanhaCrmId: atendimentosAbertos[index].tabContato.campanhaCrmId,
        consultorCarteiraId: atendimentosAbertos[index].tabContato.consultorId,
        tipoAtendimento: atendimentosAbertos[index].tabContato.tipoAtendimento,
        tipoProduto: atendimentosAbertos[index].tabContato.tipoProduto,
        callId: atendimentosAbertos[index].tabContato.infosChamada.callId
      }
    }
    const response: AxiosResponse<ReqCrm<ResponseTabulacao>> = yield call(
      atendimentoController.tabularAtendimento,
      tabulacao
    )
    yield put(
      atendimentoActions.setInfosContato(
        {
          ...atendimentosAbertos[index].tabContato,
          infosChamada: {
            ...atendimentosAbertos[index].tabContato.infosChamada,
            numeroChamada: '',
            tabulacaoChamada: null,
            dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
            horarioAgendamento: moment().format('HH:mm'),
            tipoAgendamento: '',
            observacoesAgendamento: '',
            emChamada: false,
            statusChamada: 0,
            modalDiscagem: false,
            numerosDiscados: []
          }
        },
        removeMaskCPF(atendimentosAbertos[index].cpf)
      )
    )

    if (response?.data?.content === null) {
      if (ramalAssociado.associado && statusAgente.pausado) {
        yield put(navbarActions.despausarAgenteSaga())
      }
      yield put(atendimentoActions.setAtendimentoAtivo(null))
      return yield put(atendimentoActions.endAtendimento(index))
    }

    if (
      response?.data?.content?.telefones?.length >= 0 ||
      response?.data?.content?.telefones === null
    ) {
      const telefones: InfosChamada['telefones'] = []
      response?.data?.content?.telefones?.forEach((telefone: Telefone) => {
        telefones.push({
          numero: `(${telefone.ddd}) ${telefone.numero}`,
          whatsapp: telefone.whatsapp,
          telefoneId: telefone.telefoneId
        })
      })
      yield put(
        atendimentoActions.setInfosContato(
          {
            ...atendimentosAbertos[index].tabContato,
            infosChamada: {
              ...atendimentosAbertos[index].tabContato.infosChamada,
              telefones: telefones
            }
          },
          removeMaskCPF(atendimentosAbertos[index].cpf)
        )
      )
      if (response?.data?.content?.proximoTelefone && telefones?.length > 0) {
        yield put(
          atendimentoActions.discarClienteSaga(index, telefones?.[0].telefoneId)
        )
      }
    }
    if (response?.data?.content.novoAtendimento) {
      if (response?.data?.content.atendimento?.campanhaCrmId) {
        yield put(
          inicioActions.iniciarAtendimentoCampanhasSaga(
            response?.data?.content.atendimento.campanhaCrmId
          )
        )
      }

      if (response?.data?.content.atendimento?.tipoProduto) {
        yield put(
          inicioActions.iniciarAtendimentoCarteirasSaga(
            atendimentosAbertos[index].tabContato.tipoProduto,
            atendimentosAbertos[index].tabContato.consultorId ?? ''
          )
        )
      }

      if (atendimentosAbertos[index].tabContato.tipoAtendimento === 3) {
        yield put(inicioActions.iniciarAtendimentoLeadSaga())
      }

      yield put(atendimentoActions.endAtendimento(index))
    }
    yield put(
      atendimentoActions.getAtendimentosSaga(
        atendimentosAbertos[index].cpf,
        index
      )
    )
    toast.success('Tabulação realizada com sucesso!')
  } catch (error) {
    handlerError(error, 'Não foi possível tabular o atendimento!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface TabularAtendimentoByCpfProps extends GenericProps {
  tabulacaoAutomatica?: boolean
  numeroChamada?: string
}

function* tabularAtendimentobyCpf({
  cpf,
  numeroChamada,
  tabulacaoAutomatica
}: TabularAtendimentoByCpfProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const index = atendimentosAbertos
      .map((atendimento) => {
        return atendimento.cpf
      })
      .indexOf(cpf)
    if (index !== -1) {
      let tabulacao: TabulacaoAtendimento
      if (
        atendimentosAbertos[index].tabContato.infosChamada.tabulacaoChamada
          ?.personalizado
      ) {
        tabulacao = {
          atendimentoId: atendimentosAbertos[index].tabContato.atendimentoId,
          cpf: atendimentosAbertos[index].cpf,
          ddd:
            numeroChamada?.substring(1, 3) ||
            atendimentosAbertos[
              index
            ].tabContato.infosChamada.numeroChamada?.substring(1, 3),
          telefone:
            numeroChamada?.substring(5).replace('-', '') ||
            atendimentosAbertos[index].tabContato.infosChamada.numeroChamada
              ?.substring(5)
              .replace('-', ''),
          tabulacaoId:
            atendimentosAbertos[index].tabContato.infosChamada.tabulacaoChamada
              ?.id,
          dataAtendimento:
            atendimentosAbertos[index].tabContato.infosChamada.dataAgendamento,
          horario:
            atendimentosAbertos[index].tabContato.infosChamada
              .horarioAgendamento,
          tipoAgendamentoId:
            atendimentosAbertos[index].tabContato.infosChamada.tipoAgendamento,
          observacoes:
            atendimentosAbertos[index].tabContato.infosChamada
              .observacoesAgendamento,
          campanhaCrmId: atendimentosAbertos[index].tabContato.campanhaCrmId,
          consultorCarteiraId:
            atendimentosAbertos[index].tabContato.consultorId,
          tipoAtendimento:
            atendimentosAbertos[index].tabContato.tipoAtendimento,
          tipoProduto: atendimentosAbertos[index].tabContato.tipoProduto,
          callId: atendimentosAbertos[index].tabContato.infosChamada.callId,
          tabulacaoAutomatica: !!tabulacaoAutomatica
        }
      } else {
        tabulacao = {
          atendimentoId: atendimentosAbertos[index].tabContato.atendimentoId,
          cpf: atendimentosAbertos[index].cpf,
          ddd:
            numeroChamada?.substring(1, 3) ||
            atendimentosAbertos[
              index
            ].tabContato.infosChamada.numeroChamada?.substring(1, 3),
          telefone:
            numeroChamada?.substring(5).replace('-', '') ||
            atendimentosAbertos[index].tabContato.infosChamada.numeroChamada
              ?.substring(5)
              .replace('-', ''),
          tabulacaoId:
            atendimentosAbertos[index].tabContato.infosChamada.tabulacaoChamada
              ?.id,
          dataAtendimento: '',
          tipoAgendamentoId: '',
          observacoes: '',
          campanhaCrmId: atendimentosAbertos[index].tabContato.campanhaCrmId,
          consultorCarteiraId:
            atendimentosAbertos[index].tabContato.consultorId,
          tipoAtendimento:
            atendimentosAbertos[index].tabContato.tipoAtendimento,
          tipoProduto: atendimentosAbertos[index].tabContato.tipoProduto,
          callId: atendimentosAbertos[index].tabContato.infosChamada.callId,
          tabulacaoAutomatica: !!tabulacaoAutomatica
        }
      }
      const response: AxiosResponse<ReqCrm<ResponseTabulacao>> = yield call(
        atendimentoController.tabularAtendimento,
        tabulacao
      )
      if (tabulacaoAutomatica) {
        let telefonesDiscados = [
          ...atendimentosAbertos[index].tabContato.infosChamada.numerosDiscados
        ]
        telefonesDiscados = telefonesDiscados?.filter(
          (telefone) =>
            telefone !==
            (numeroChamada ||
              maskPhoneWithDDD(
                atendimentosAbertos[
                  index
                ].tabContato.infosChamada.numeroChamada?.substring(1, 3) +
                  atendimentosAbertos[
                    index
                  ].tabContato.infosChamada.numeroChamada
                    ?.substring(5)
                    .replace('-', '')
              ))
        )
        yield put(
          atendimentoActions.setInfosContato(
            {
              ...atendimentosAbertos[index].tabContato,
              infosChamada: {
                ...atendimentosAbertos[index].tabContato.infosChamada,
                tabulacaoChamada: null,
                dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
                horarioAgendamento: moment().format('HH:mm'),
                tipoAgendamento: '',
                observacoesAgendamento: '',
                numerosDiscados: telefonesDiscados ?? [],
                modalDiscagem: telefonesDiscados?.length > 0
              }
            },
            removeMaskCPF(atendimentosAbertos[index].cpf)
          )
        )
      } else {
        yield put(
          atendimentoActions.setInfosContato(
            {
              ...atendimentosAbertos[index].tabContato,
              infosChamada: {
                ...atendimentosAbertos[index].tabContato.infosChamada,
                numeroChamada: '',
                tabulacaoChamada: null,
                dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
                horarioAgendamento: moment().format('HH:mm'),
                tipoAgendamento: '',
                observacoesAgendamento: '',
                emChamada: false,
                statusChamada: 0,
                modalDiscagem: false,
                numerosDiscados: []
              }
            },
            removeMaskCPF(atendimentosAbertos[index].cpf)
          )
        )
      }
      if (
        response?.data?.content?.telefones?.length >= 0 ||
        response?.data?.content?.telefones === null
      ) {
        const telefones: InfosChamada['telefones'] = []
        response?.data?.content?.telefones?.forEach((telefone: Telefone) => {
          telefones.push({
            numero: `(${telefone.ddd}) ${telefone.numero}`,
            whatsapp: telefone.whatsapp,
            telefoneId: telefone.telefoneId
          })
        })
        yield put(
          atendimentoActions.setInfosContato(
            {
              ...atendimentosAbertos[index].tabContato,
              infosChamada: {
                ...atendimentosAbertos[index].tabContato.infosChamada,
                telefones: telefones
              }
            },
            removeMaskCPF(atendimentosAbertos[index].cpf)
          )
        )
        if (response?.data?.content?.proximoTelefone && telefones?.length > 0) {
          yield put(
            atendimentoActions.discarClienteSaga(
              index,
              telefones?.[0].telefoneId
            )
          )
        }
        if (response?.data?.content?.telefones?.length === 0) {
          yield put(atendimentoActions.validarNovoAtendimentoSaga(cpf, index))
          yield take(TYPES.VALIDAR_NOVO_ATENDIMENTO_SUCCESS)
        }
      }
      yield put(
        atendimentoActions.getAtendimentosSaga(
          atendimentosAbertos[index].cpf,
          index
        )
      )
      toast.success('Tabulação realizada com sucesso!')
    }
  } catch (error) {
    handlerError(error, 'Não foi possível tabular o atendimento!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getPropostasCrm({ cpf, index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )

  let clienteNaoElegivel = false
  let clienteNaoElegivelIndicacao = false
  const mensagemModalIndicacao: string[] = []
  const mensagemModalElegibilidade: string[] = []

  try {
    yield call(clearNotifications, index)
    yield put(atendimentoActions.setLoadingSimulacao(true, index))
    yield put(
      atendimentoActions.setInfosProduto([], 'produtosDisponiveis', index)
    )
    yield put(
      atendimentoActions.setInfosProduto([], 'produtosSelecionados', index)
    )
    const cpfFormated = removeMaskCPF(cpf)
    let response: ProdutoSimulacao[] = []
    const getSimulacoes = function* (): Generator<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      AllEffect<Generator<CallEffect<AxiosResponse<any, any>>, any, unknown>>,
      void,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      AxiosResponse<ReqCrmSimulacao<any>, any>[]
    > {
      const filteredBeneficios = atendimentosAbertos[
        index
      ].tabProduto.beneficios?.filter(
        (beneficio) => beneficio.clientePerfil.tipoPerfil !== 2
      )

      const getPropostaCrefaz = function* () {
        try {
          const response: AxiosResponse<
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ReqCrmSimulacao<any>,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            any
          > = yield call(atendimentoController.getPropostasCrefaz, cpfFormated)
          return response
        } catch (error) {
          handlerErrorSimulationService(
            error,
            index,
            'Houve um erro ao realizar a simulação, tente novamente mais tarde.'
          )
          return null
        }
      }

      const responses = yield all([
        ...filteredBeneficios.map(function* (beneficio) {
          try {
            const response: AxiosResponse<
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              ReqCrmSimulacao<any>,
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              any
            > = yield call(
              atendimentoController.getPropostasCrm,
              cpfFormated,
              beneficio.numero
            )
            return response
          } catch (error) {
            handlerErrorSimulationService(
              error,
              index,
              'Houve um erro ao realizar a simulação, tente novamente mais tarde.'
            )
            return null
          }
        }),
        getPropostaCrefaz()
      ])

      responses?.map((res, idx) => {
        if (res?.data?.content || res?.data?.content?.length > 0) {
          if (Array.isArray(res?.data?.content)) {
            response = response.concat(res?.data?.content)
          } else {
            if (!res?.data?.content?.mensagemModal) {
              response.push(res?.data?.content)
            }
          }
        }

        if (res?.data?.mensagensErro && res?.data?.mensagensErro?.length > 0) {
          handlerErrorSimulationService(res?.data, index)
        }

        if (idx < filteredBeneficios.length) {
          const beneficioNumero = filteredBeneficios[idx].numero
          if (res?.data?.modalElegibilidade) {
            clienteNaoElegivel = true
            const mensagem = `${res?.data?.content?.mensagemModal} - Matrícula: ${beneficioNumero}`
            mensagemModalElegibilidade.push(mensagem)
          }

          if (res?.data?.content?.modalInegibilidade) {
            clienteNaoElegivelIndicacao = true
            const mensagemIndicacao = `${res?.data?.content?.mensagemInegibilidade} - Matrícula: ${beneficioNumero}`
            mensagemModalIndicacao.push(mensagemIndicacao)
          }
        }
      })
    }

    yield call(getSimulacoes)

    let produtosDisponiveis: ProdutoSimulacao[] = []
    const codigoPlanoConsignado: {
      matricula: string
      value: number
      valorPremio: number
    }[] = []

    const codigoPlanoBeneficio: {
      matricula: string
      value: number
      valorPremio: number
    }[] = []
    const codigoPlanoCartaoBeneficio: {
      matricula: string
      value: number
      valorPremio: number
    }[] = []
    const codigoPlanoCartaoConsignado: {
      matricula: string
      value: number
      valorPremio: number
      flagSaqueParcelado: boolean
    }[] = []
    let contratoPortabilidadeFormatted: ProdutoSimulacao['contratosPortabilidade'] =
      []

    for (const produto of response) {
      let simulacoesCrefaz: SimulacaoCrefaz[] = []
      const maiorValorPremioSeguroPrestamista =
        produto.planosSeguroPrestamista?.planosComLimiteSaque?.reduce(
          (max: number, plano) => {
            return plano.valorPremio > max ? plano.valorPremio : max
          },
          produto.planosSeguroPrestamista?.planosComLimiteSaque[0].valorPremio
        )
      if (maiorValorPremioSeguroPrestamista !== undefined) {
        const plano =
          produto.planosSeguroPrestamista?.planosComLimiteSaque?.find(
            (plano) => plano.valorPremio === maiorValorPremioSeguroPrestamista
          )

        if (produto.servico === 5) {
          codigoPlanoConsignado.push({
            matricula: produto.matricula,
            value: plano?.codigoPlano ?? 0,
            valorPremio: maiorValorPremioSeguroPrestamista ?? 0
          })
        }
        if (produto.servico === 6) {
          codigoPlanoCartaoConsignado.push({
            matricula: produto.matricula,
            value: plano?.codigoPlano ?? 0,
            valorPremio: maiorValorPremioSeguroPrestamista ?? 0,
            flagSaqueParcelado: true
          })
        }
        if (produto.servico === 7) {
          codigoPlanoCartaoBeneficio.push({
            matricula: produto.matricula,
            value: plano?.codigoPlano ?? 0,
            valorPremio: maiorValorPremioSeguroPrestamista ?? 0
          })
        }

        if (produto.servico === 8) {
          codigoPlanoBeneficio.push({
            matricula: produto.matricula,
            value: plano?.codigoPlano ?? 0,
            valorPremio: maiorValorPremioSeguroPrestamista ?? 0
          })
        }
      }

      if (produto.servico === 3) {
        contratoPortabilidadeFormatted = produto.contratosPortabilidade?.map(
          (contratoPortabilidade) => ({
            ...contratoPortabilidade,
            listProdutosPortabilidade:
              contratoPortabilidade.listProdutosPortabilidade.map(
                (produtoPortabilidade, produtoPortabilidadeIndex) => ({
                  ...produtoPortabilidade,
                  produtosAssociados:
                    produtoPortabilidade.produtosAssociados.map(
                      (produtoAssociado, produtoAssociadoIndex) => ({
                        ...produtoAssociado,
                        selecionado: produtoAssociadoIndex === 0
                      })
                    ),
                  selecionado: produtoPortabilidadeIndex === 0
                })
              )
          })
        )
      }

      if (produto.servico === 13) {
        simulacoesCrefaz =
          produto.simulacoesCrefaz?.map((simulacao) => {
            const maiorValorLiberado =
              simulacao.empresasConveniadas?.[0].listaValoresLiberados?.reduce(
                (max, item) => {
                  return item.valor > max.valor ? item : max
                },
                simulacao.empresasConveniadas?.[0].listaValoresLiberados?.[0]
              )

            const maiorPrazo = maiorValorLiberado.listaParcelas?.reduce(
              (max, item) => {
                return item.prazo > max.prazo ? item : max
              },
              maiorValorLiberado.listaParcelas[0]
            )
            return {
              ...simulacao,
              selecionados: {
                convenioDados: [
                  ...(simulacao.empresasConveniadas?.[0].convenioDados || [])
                ],
                convenioId: simulacao.empresasConveniadas?.[0].convenioId ?? 0,
                prazo: maiorPrazo?.prazo ?? null,
                valorParcela: maiorPrazo?.valor ?? null,
                valorSolicitado: maiorValorLiberado?.valor ?? 0
              }
            }
          }) ?? []
      }

      produtosDisponiveis.push({
        banco: produto.banco,
        codigoFator: produto.codigoFator,
        codigoProduto: produto.codigoProduto,
        codigoSimulacao: produto.codigoSimulacao,
        codigoFormaEnvioTermo: produto.codigoFormaEnvioTermo,
        clienteElegivel: produto.clienteElegivel,
        contratoRefinanciamento: produto.contratoRefinanciamento,
        erros: produto.erros,
        cpf: produto.cpf,
        id: produto.id,
        listProdutos: produto.listProdutos,
        listParcelas: produto.listParcelas,
        mensagemOperadora: produto.mensagemOperadora,
        matricula: produto.matricula,
        perfil: produto.perfil,
        porcentagemFator: produto.porcentagemFator,
        quantidadeParcelas: produto.quantidadeParcelas,
        servico: produto.servico,
        valorSolicitado: produto.valorSolicitado,
        valorLimite: produto.valorLimite,
        valorParcela: produto.valorParcela,
        valorLiberado: produto.valorLiberado,
        valorSaqueMaximo: produto.valorSaqueMaximo,
        valorSaqueMinimo: produto.valorSaqueMinimo,
        valorTotalFinanciado: produto.valorTotalFinanciado,
        flagSaqueAutorizado:
          produto.servico === 5 ||
          produto.servico === 8 ||
          produto.servico === 12, //Desabilitando campo do cartão benefício até que seja integrado: produto.servico === 5 || produto.servico === 6 || produto.servico === 7 || produto.servico === 8
        flagSaqueParcelado:
          produto.servico === 5 ||
          produto.servico === 7 ||
          produto.servico === 6 ||
          produto.servico === 8,
        valorSaque: maskMoney(Number(produto.valorSaque).toFixed(2)),
        flagAberturaConta: false,
        bancoSimulacaoEnum: produto.bancoSimulacaoEnum,
        margemDisponivel: produto.margemDisponivel,
        margemDisponivelCartao: produto.margemDisponivelCartao,
        margemDisponivelCartaoBeneficio:
          produto.margemDisponivelCartaoBeneficio,
        produtosSINDNAP: produto.produtosSINDNAP,
        tipoProduto: produto.tipoProduto,
        tipoOperacao: produto.tipoOperacao,
        numeroContaInterna: produto.numeroContaInterna,
        permiteAgregacaoRefin: produto.permiteAgregacaoRefin,
        valorMargem: produto.valorMargem,
        limiteCartao: produto.limiteCartao,
        limiteDisponivel: produto.limiteDisponivel,
        planosSeguroPrestamista: produto.planosSeguroPrestamista,
        tipoSaque: produto.tipoSaque,
        modalIndicacao: produto.modalIndicacao,
        mensagemModalIndicacao: produto.mensagemModalIndicacao,
        modalInegibilidade: produto.modalInegibilidade,
        mensagemInegibilidade: produto.mensagemInegibilidade,
        contratosPortabilidade: contratoPortabilidadeFormatted,
        simulacoesCrefaz: simulacoesCrefaz,
        seguroPrestamistaEmprestimo: produto.seguroPrestamistaEmprestimo,
        flagSeguroPrestamista: produto.seguroPrestamistaEmprestimo !== null
      })
    }

    yield put(
      atendimentoActions.setInfosProduto(
        codigoPlanoConsignado,
        'listPlanoSeguroPrestamistaConsignadoSelecionadoByMatricula',
        index
      )
    )

    yield put(
      atendimentoActions.setInfosProduto(
        codigoPlanoBeneficio,
        'listPlanoSeguroPrestamistaBeneficioSelecionadoByMatricula',
        index
      )
    )

    yield put(
      atendimentoActions.setInfosProduto(
        codigoPlanoCartaoBeneficio,
        'listPlanoSeguroPrestamistaCartaoBeneficioSelecionadoByMatricula',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosProduto(
        codigoPlanoCartaoConsignado,
        'listPlanoSeguroPrestamistaCartaoConsignadoSelecionadoByMatricula',
        index
      )
    )
    const produtosSindnapi = response.filter(
      (produto: ProdutoSimulacao) => produto.servico === 12
    )
    let produtoMaiorValor: ProdutoSimulacao | null = null
    let maiorValor = 0
    produtosSindnapi.map((produto: ProdutoSimulacao) => {
      if (
        (produto.produtosSINDNAP?.planos?.[0]?.valorPremioAux ?? 0) > maiorValor
      ) {
        maiorValor = produto.produtosSINDNAP?.planos[0].valorPremioAux ?? 0
        produtoMaiorValor = produto
      }
    })
    if (produtoMaiorValor) {
      produtosDisponiveis = produtosDisponiveis?.filter(
        (produto) => produto.servico !== 12
      )
      produtosDisponiveis.push(produtoMaiorValor)
    }

    if (
      produtosDisponiveis.some(
        (produto) =>
          produto.modalInegibilidade &&
          ((produto.servico === 1 && produto.id === null) ||
            (produto.servico === 2 && produto.id === null))
      )
    ) {
      yield put(
        atendimentoActions.setInfosProduto(true, 'modalInegibilidade', index)
      )

      const mensagensInegibilidade = produtosDisponiveis
        .filter(
          (produto) =>
            produto.modalInegibilidade &&
            (produto.servico === 1 || produto.servico === 2)
        )
        .map((produto) => produto.mensagemInegibilidade)

      yield put(
        atendimentoActions.setInfosProduto(
          mensagensInegibilidade,
          'mensagemInegibilidade',
          index
        )
      )

      produtosDisponiveis = produtosDisponiveis.filter(
        (produto) =>
          !(
            produto.modalInegibilidade &&
            ((produto.servico === 1 && produto.id === null) ||
              (produto.servico === 2 && produto.id === null))
          )
      )
    }

    yield put(
      atendimentoActions.setInfosProduto(
        [...produtosDisponiveis],
        'produtosDisponiveis',
        index
      )
    )

    const newProdutosDisponiveis = [
      ...produtosDisponiveis.filter((produto) => {
        return !(
          ((produto.servico === 5 || produto.servico === 8) &&
            produto.valorTotalFinanciado === 0) ||
          (produto.servico === 2 && produto.clienteElegivel === false)
        )
      })
    ]

    const margemDisponivelByMatricula: {
      matricula: string
      value: number
    }[] = []

    const listProdutosRefinQtdDeParcelasOriginaisByContrato: {
      contrato: string
      value: number
    }[] = []

    newProdutosDisponiveis.forEach((produto) => {
      if (produto.servico === 2 && produto.matricula) {
        if (produto.contratoRefinanciamento) {
          listProdutosRefinQtdDeParcelasOriginaisByContrato.push({
            contrato:
              produto.contratoRefinanciamento.numeroOperacaoCreditoExterno,
            value: produto.quantidadeParcelas
          })
        }

        const isMatriculaAlreadyAdded = margemDisponivelByMatricula.some(
          (item) => item.matricula === produto.matricula
        )

        if (isMatriculaAlreadyAdded) return

        margemDisponivelByMatricula.push({
          matricula: produto.matricula,
          value: produto.margemDisponivel
        })
      }
    })

    const listCodigoTabelaSelectedByCodigoSimulacao: {
      id: number
      value: number
    }[] = []
    const listParcelasSelectedByCodigoSimulacao: {
      id: number
      value: number
    }[] = []

    newProdutosDisponiveis.forEach((produto) => {
      if (
        produto.servico === 2 &&
        produto.clienteElegivel &&
        produto.codigoSimulacao
      ) {
        listCodigoTabelaSelectedByCodigoSimulacao.push({
          id: produto.codigoSimulacao,
          value: produto.listProdutos[0].codigo
        })

        const listParcelas = produto.listProdutos[0].listParcelas

        const newParcelasSelected = listParcelas?.reduce(
          (max: number, parcela: ListaParcelasEValorTotalSimulacao) => {
            return parcela.parcelas > max ? parcela.parcelas : max
          },
          listParcelas[0].parcelas
        )

        listParcelasSelectedByCodigoSimulacao.push({
          id: produto.codigoSimulacao,
          value: newParcelasSelected
        })
      }
    })

    yield put(
      atendimentoActions.setInfosProduto(
        margemDisponivelByMatricula,
        'margemDisponivelByMatricula',
        index
      )
    )

    yield put(
      atendimentoActions.setInfosProduto(
        listProdutosRefinQtdDeParcelasOriginaisByContrato,
        'listProdutosRefinQtdDeParcelasOriginaisByContrato',
        index
      )
    )

    yield put(
      atendimentoActions.setInfosProduto(
        listCodigoTabelaSelectedByCodigoSimulacao,
        'listCodigoTabelaSelectedByCodigoSimulacao',
        index
      )
    )

    yield put(
      atendimentoActions.setInfosProduto(
        listParcelasSelectedByCodigoSimulacao,
        'listParcelasSelectedByCodigoSimulacao',
        index
      )
    )

    yield put(
      atendimentoActions.setInfosProduto(
        newProdutosDisponiveis,
        'produtosSelecionados',
        index
      )
    )
    const valorTotalNumerico = {
      cf_site_valor_disponivel_cartao_beneficio: 0,
      cf_site_valor_disponivel_cartao_consignado: 0,
      cf_site_valor_disponivel_saque_aniversario_fgts: 0,
      cf_site_valor_disponivel_saque_cartao_beneficio: 0,
      cf_site_valor_disponivel_saque_cartao_consignado: 0,
      cf_site_valor_disponivel_crefaz: 0,
      cf_site_valor_disponivel_portabilidade: 0,
      cf_site_valor_disponivel_refin: 0,
      cf_site_valor_disponivel_emprestimo_consignado: 0
    }

    produtosDisponiveis.forEach((produto) => {
      const { valorTotalFinanciado, valorSaque, valorPremioAux } = (() => {
        const valorTotalFinanciado = Number(produto.valorTotalFinanciado ?? 0)

        const valorSaque = produto.valorSaque
          ? Number(removeMaskMoney(produto.valorSaque))
          : 0

        const valorPremioAux = Number(
          produto.produtosSINDNAP?.planos?.[0]?.valorPremioAux ?? 0
        )

        return {
          valorTotalFinanciado,
          valorSaque,
          valorPremioAux
        }
      })()

      switch (produto.servico) {
        case 6:
          valorTotalNumerico.cf_site_valor_disponivel_cartao_consignado +=
            valorSaque
          break
        case 7:
          valorTotalNumerico.cf_site_valor_disponivel_cartao_beneficio +=
            valorSaque
          break
        case 8:
          valorTotalNumerico.cf_site_valor_disponivel_saque_cartao_beneficio +=
            valorSaque
          break
        case 5:
          valorTotalNumerico.cf_site_valor_disponivel_saque_cartao_consignado +=
            valorSaque
          break
        case 9:
          valorTotalNumerico.cf_site_valor_disponivel_saque_aniversario_fgts +=
            valorSaque
          break
        case 13:
          valorTotalNumerico.cf_site_valor_disponivel_crefaz += valorPremioAux
          break
        case 2:
          if (produto.clienteElegivel) {
            valorTotalNumerico.cf_site_valor_disponivel_refin +=
              valorTotalFinanciado
          }
          break
        case 3:
          if (
            produto.contratosPortabilidade &&
            produto.contratosPortabilidade.length > 0
          ) {
            produto.contratosPortabilidade.forEach((contrato) => {
              contrato.listProdutosPortabilidade?.forEach(
                (prodPortabilidade) => {
                  prodPortabilidade.produtosAssociados?.forEach(
                    (prodAssociado) => {
                      valorTotalNumerico.cf_site_valor_disponivel_portabilidade +=
                        prodAssociado.valorTotalFinanciado ?? 0
                    }
                  )
                }
              )
            })
          }
          break
        case 1:
          valorTotalNumerico.cf_site_valor_disponivel_emprestimo_consignado +=
            valorTotalFinanciado
          break
      }
    })

    const valorTotalPorProduto = Object.fromEntries(
      Object.entries(valorTotalNumerico).map(([chave, valor]) => [
        chave,
        valor > 0 ? valor.toFixed(2) : ''
      ])
    )

    const somatorioTotalProdutos = produtosDisponiveis
      .map((produto) => {
        if (
          produto.servico === 5 ||
          produto.servico === 6 ||
          produto.servico === 7 ||
          produto.servico === 8 ||
          produto.servico === 12
        ) {
          if (!produto.flagSaqueAutorizado && !produto.flagSaqueParcelado) {
            return 0
          } else {
            return Number(removeMaskMoney(produto.valorSaque))
          }
        } else if (produto.servico === 2 && produto.clienteElegivel) {
          const codigoTabelaSelected = atendimentosAbertos[
            index
          ].tabProduto.listCodigoTabelaSelectedByCodigoSimulacao?.find(
            (item) => item.id === produto.codigoSimulacao
          )?.value

          const parcelasSelected = atendimentosAbertos[
            index
          ].tabProduto.listParcelasSelectedByCodigoSimulacao?.find(
            (item) => item.id === produto.codigoSimulacao
          )?.value

          const indexTabelaSelected =
            produto.listProdutos?.findIndex(
              (p) => p.codigo === codigoTabelaSelected
            ) ?? 0

          const indexParcelaSelected =
            produto.listProdutos?.[indexTabelaSelected]?.listParcelas.findIndex(
              (p) => p.parcelas === parcelasSelected
            ) ?? 0

          return (
            produto.listProdutos[indexTabelaSelected]?.listParcelas[
              indexParcelaSelected
            ]?.valorLiberado ?? 0
          )
        } else if (
          produto.servico === 3 &&
          produto.contratosPortabilidade?.some(
            (contrato) => contrato.clienteElegivel
          )
        ) {
          let valorTotalFinanciado = 0
          const { contratosPortabilidade } = produto

          if (contratosPortabilidade) {
            contratosPortabilidade
              .filter((contrato) => contrato.clienteElegivel)
              .forEach((contrato) => {
                contrato.listProdutosPortabilidade
                  .filter(
                    (produtoPortabilidade) => produtoPortabilidade.selecionado
                  )
                  .forEach((produtoPortabilidade) => {
                    valorTotalFinanciado +=
                      produtoPortabilidade.produtosAssociados
                        .filter(
                          (produtoAssociado) => produtoAssociado.selecionado
                        )
                        .reduce((acc, produtoAssociado) => {
                          return (
                            acc + (produtoAssociado.valorTotalFinanciado ?? 0)
                          )
                        }, 0)
                  })
              })
          }
          return valorTotalFinanciado
        } else if (produto.servico === 13) {
          let valor = 0
          for (const simulacao of produto.simulacoesCrefaz ?? []) {
            valor += simulacao.selecionados.valorSolicitado
          }
          return valor
        } else if (produto.servico === 1) {
          return produto.seguroPrestamistaEmprestimo &&
            produto.flagSeguroPrestamista
            ? produto.valorLiberado
            : produto.valorSolicitado
        } else {
          return produto.valorTotalFinanciado
        }
      })
      .reduce((acc, curr) => acc + curr, 0)

    if (atendimentosAbertos[index].tabContato.clienteSite) {
      yield call(atendimentoController.atualizarContatoRd, cpfFormated, {
        cf_site_valor_total_disponivel: String(
          somatorioTotalProdutos.toFixed(2)
        ),
        tags: ['etapa simulacao_crm'],
        ...valorTotalPorProduto
      })
    }

    yield put(
      atendimentoActions.setInfosContato(
        {
          ...atendimentosAbertos[index].tabContato,
          infosChamada: {
            ...atendimentosAbertos[index].tabContato.infosChamada,
            tabulacaoChamada: null,
            dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
            horarioAgendamento: moment().format('HH:mm'),
            tipoAgendamento: '',
            observacoesAgendamento: '',
            emChamada: false,
            statusChamada: 0,
            modalDiscagem: false,
            numerosDiscados: []
          }
        },
        removeMaskCPF(atendimentosAbertos[index].cpf)
      )
    )
  } catch (error) {
    handlerErrorSimulationService(
      error,
      index,
      'Houve um erro ao realizar a simulação, tente novamente mais tarde.'
    )
  } finally {
    yield put(atendimentoActions.setLoadingSimulacao(false, index))
    if (
      atendimentosAbertos[index].tabProduto.beneficios.find(
        (Beneficio) => Beneficio.clientePerfil.tipoPerfil === 2
      )
    ) {
      yield put(atendimentoActions.solicitarSimulacaoFgtsSaga(cpf, index))
    }
  }
  if (clienteNaoElegivel) {
    yield put(
      atendimentoActions.setInfosProduto(
        mensagemModalElegibilidade,
        'mensagemInegibilidade',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosProduto(true, 'modalInegibilidade', index)
    )
  }

  if (clienteNaoElegivelIndicacao) {
    yield put(
      atendimentoActions.setInfosProduto(
        mensagemModalIndicacao,
        'mensagemInegibilidade',
        index
      )
    )
    yield put(atendimentoActions.setInfosProduto(true, 'modalIndicacao', index))
  }
}

function* solicitarSimulacaoFgts({ cpf, index }: GenericProps): SagaIterator {
  try {
    yield put(atendimentoActions.setLoadingSimulacao(true, index))
    const cpfFormated = removeMaskCPF(cpf)
    const response = yield call(
      atendimentoController.solicitarSimulacaoFgts,
      cpfFormated
    )
    if (
      response?.data?.mensagensErro &&
      response?.data?.mensagensErro?.length > 0
    ) {
      handlerErrorSimulationService(response?.data, index)
    }
  } catch (error) {
    handlerErrorSimulationService(
      error,
      index,
      'Houve um erro ao solicitar a simulação do FGTS, tente novamente mais tarde.'
    )
  } finally {
    yield put(atendimentoActions.setLoadingSimulacao(false, index))
    yield put(atendimentoActions.getParcelasFgtsSaga(cpf, index))
  }
}

function* getParcelasFgts({ cpf, index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(atendimentoActions.setLoadingSimulacao(true, index))
    const cpfFormated = removeMaskCPF(cpf)
    const response = yield call(
      atendimentoController.getParcelaFgts,
      cpfFormated
    )
    const produtosDisponiveis = [
      ...atendimentosAbertos[index].tabProduto.produtosDisponiveis
    ]
    const produtosSelecionados = [
      ...atendimentosAbertos[index].tabProduto.produtosSelecionados
    ]

    const iDisponivel = produtosDisponiveis.findIndex(
      (produto) => produto.servico === 9
    )
    const iSelecionado = produtosSelecionados.findIndex(
      (produto) => produto.servico === 9
    )
    if (iDisponivel !== -1) {
      produtosDisponiveis.splice(iDisponivel, 1)
    }
    if (iSelecionado !== -1) {
      produtosSelecionados.splice(iSelecionado, 1)
    }

    if (response?.data?.content && response?.data?.content.hoje) {
      const produtoFgts: ProdutoSimulacao = {
        id: 'fgts',
        perfil: 1,
        quantidadeParcelas: Number(response?.data?.content?.quantidadeParcelas),
        servico: 9,
        valorTotalFinanciado: Number(response?.data?.content?.valorLiberado),
        parcelaFgtsItem: response?.data?.content?.parcelaFgtsItem,
        banco: 'BMG',
        codigoFator: '',
        codigoProduto: null,
        cpf: cpfFormated,
        listProdutos: [],
        listParcelas: [],
        mensagemOperadora: null,
        matricula: '0',
        porcentagemFator: 0,
        valorSolicitado: 0,
        valorLimite: 0,
        valorParcela: 0,
        valorLiberado: 0,
        valorSaqueMaximo: 0,
        valorSaqueMinimo: 0,
        flagSaqueAutorizado: false,
        flagSaqueParcelado: false,
        flagAberturaConta: false,
        bancoSimulacaoEnum: 0,
        margemDisponivel: 0,
        margemDisponivelCartao: 0,
        margemDisponivelCartaoBeneficio: 0,
        tipoProduto: 0,
        valorSaque: maskMoney(0),
        produtosSINDNAP: undefined,
        numeroContaInterna: null,
        clienteElegivel: false,
        contratoRefinanciamento: undefined,
        permiteAgregacaoRefin: false,
        valorMargem: 0,
        limiteCartao: 0,
        limiteDisponivel: 0,
        tipoSaque: 0
      }
      produtosDisponiveis.push(produtoFgts)
      produtosSelecionados.push(produtoFgts)
    }
    yield put(
      atendimentoActions.setInfosProduto(
        produtosDisponiveis,
        'produtosDisponiveis',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosProduto(
        produtosSelecionados,
        'produtosSelecionados',
        index
      )
    )
    if (
      response?.data?.mensagensErro &&
      response?.data?.mensagensErro?.length > 0
    ) {
      handlerErrorSimulationService(response?.data, index)
    }
  } catch (error) {
    handlerErrorSimulationService(
      error,
      index,
      'Houve um erro ao obter a oferta do FGTS, tente novamente mais tarde.'
    )
  } finally {
    yield put(atendimentoActions.setLoadingSimulacao(false, index))
  }
}

interface RecalculoPropostaProps extends GenericProps {
  numeroMatricula: string
  quantidadeparcelas: number
  valorTotalFinanciado: number
  valorParcela: number
  servico: number
  codigoProduto: number
  banco: number
  numeroProposta: string | null
  taxaOrigem: number | null
  quantidadeTotalParcelas: number
  saldoDevedor: number | null
  indexPortabilidade: number | null
  indexRefinPortabilidade: number | null
  codigoBanco: string | null
}

export function* recalculoProposta({
  cpf,
  numeroMatricula,
  quantidadeparcelas,
  valorTotalFinanciado,
  valorParcela,
  servico,
  codigoProduto,
  banco,
  numeroProposta,
  taxaOrigem,
  quantidadeTotalParcelas,
  saldoDevedor,
  index,
  indexPortabilidade,
  indexRefinPortabilidade,
  codigoBanco
}: RecalculoPropostaProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(cpf)
    const response = yield call(() =>
      atendimentoController.recalculoProposta(
        cpfFormated,
        numeroMatricula,
        quantidadeparcelas,
        valorTotalFinanciado,
        valorParcela,
        servico,
        codigoProduto,
        banco,
        numeroProposta || null,
        taxaOrigem || null,
        quantidadeTotalParcelas,
        saldoDevedor || null,
        codigoBanco || null
      )
    )
    const produtosDisponiveis = [
      ...atendimentosAbertos[index].tabProduto.produtosDisponiveis
    ]
    const produtosSelecionados = [
      ...atendimentosAbertos[index].tabProduto.produtosSelecionados
    ]
    const indexDisponiveis = produtosDisponiveis.findIndex(
      (produto) =>
        produto.servico === response?.data?.content?.servico &&
        produto.matricula === response?.data?.content?.matricula
    )
    const indexSelecionados = produtosSelecionados.findIndex(
      (produto) =>
        produto.servico === response?.data?.content?.servico &&
        produto.matricula === response?.data?.content?.matricula
    )
    if (servico !== 3) {
      if (indexDisponiveis !== -1) {
        produtosDisponiveis[indexDisponiveis] = {
          ...produtosDisponiveis[indexDisponiveis],
          ...response?.data?.content,
          valorSaque: maskMoney(response?.data?.content?.valorSaque?.toFixed(2))
        }
      }
      if (indexSelecionados !== -1) {
        produtosSelecionados[indexSelecionados] = {
          ...produtosDisponiveis[indexDisponiveis],
          ...response?.data?.content,
          valorSaque: maskMoney(response?.data?.content?.valorSaque?.toFixed(2))
        }
      }
    }
    if (servico === 3) {
      if (indexDisponiveis !== -1) {
        const contratos =
          produtosDisponiveis[indexDisponiveis].contratosPortabilidade
        const indexContrato = produtosDisponiveis[
          indexDisponiveis
        ].contratosPortabilidade?.findIndex(
          (contratoPortabilidade) =>
            maskNumber(contratoPortabilidade.numeroProposta) ===
            maskNumber(numeroProposta)
        )
        if (contratos) {
          if (indexContrato !== -1) {
            const contrato = contratos[indexContrato ?? 0]
            const listProdutosPortabilidade =
              contrato.listProdutosPortabilidade || []

            if (listProdutosPortabilidade[indexPortabilidade ?? 0]) {
              const produtoPortabilidade =
                listProdutosPortabilidade[indexPortabilidade ?? 0]
              const produtosAssociados =
                produtoPortabilidade.produtosAssociados || []

              produtosAssociados[indexRefinPortabilidade ?? 0] = {
                ...response?.data?.content?.contratosPortabilidade?.[0]
                  .listProdutosPortabilidade?.[0].produtosAssociados?.[0],
                selecionado:
                  produtosAssociados[indexRefinPortabilidade ?? 0].selecionado
              }

              produtoPortabilidade.produtosAssociados = produtosAssociados

              listProdutosPortabilidade[indexPortabilidade ?? 0] = {
                ...response?.data?.content?.contratosPortabilidade?.[0]
                  .listProdutosPortabilidade?.[0],
                produtosAssociados: produtosAssociados,
                selecionado:
                  listProdutosPortabilidade[indexPortabilidade ?? 0].selecionado
              }
            }
            if (
              (indexContrato || indexContrato === 0) &&
              produtosDisponiveis &&
              produtosDisponiveis[indexDisponiveis] &&
              produtosDisponiveis[indexDisponiveis].contratosPortabilidade &&
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              produtosDisponiveis[indexDisponiveis].contratosPortabilidade![
                indexContrato
              ]
            ) {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              produtosDisponiveis[indexDisponiveis].contratosPortabilidade![
                indexContrato
              ] = {
                ...response?.data?.content?.contratosPortabilidade?.[0],
                listProdutosPortabilidade: listProdutosPortabilidade
              }
            }
          }
        }
      }
      if (indexSelecionados !== -1) {
        const contratos =
          produtosSelecionados[indexSelecionados].contratosPortabilidade
        const indexContrato = produtosSelecionados[
          indexSelecionados
        ].contratosPortabilidade?.findIndex(
          (contratoPortabilidade) =>
            maskNumber(contratoPortabilidade.numeroProposta) ===
            maskNumber(numeroProposta)
        )
        if (contratos) {
          if (indexContrato !== -1) {
            const contrato = contratos[indexContrato ?? 0]
            const listProdutosPortabilidade =
              contrato.listProdutosPortabilidade || []

            if (listProdutosPortabilidade[indexPortabilidade ?? 0]) {
              const produtoPortabilidade =
                listProdutosPortabilidade[indexPortabilidade ?? 0]
              const produtosAssociados =
                produtoPortabilidade.produtosAssociados || []

              produtosAssociados[indexRefinPortabilidade ?? 0] = {
                ...response?.data?.content?.contratosPortabilidade?.[0]
                  .listProdutosPortabilidade?.[0].produtosAssociados?.[0],
                selecionado:
                  produtosAssociados[indexRefinPortabilidade ?? 0].selecionado
              }

              produtoPortabilidade.produtosAssociados = produtosAssociados

              listProdutosPortabilidade[indexPortabilidade ?? 0] = {
                ...response?.data?.content?.contratosPortabilidade?.[0]
                  .listProdutosPortabilidade?.[0],
                produtosAssociados: produtosAssociados,
                selecionado:
                  listProdutosPortabilidade[indexPortabilidade ?? 0].selecionado
              }
            }
            if (
              (indexContrato || indexContrato === 0) &&
              produtosSelecionados &&
              produtosSelecionados[indexSelecionados] &&
              produtosSelecionados[indexSelecionados].contratosPortabilidade &&
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              produtosSelecionados[indexSelecionados].contratosPortabilidade![
                indexContrato
              ]
            ) {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              produtosSelecionados[indexSelecionados].contratosPortabilidade![
                indexContrato
              ] = {
                ...response?.data?.content?.contratosPortabilidade?.[0],
                listProdutosPortabilidade: listProdutosPortabilidade
              }
            }
          }
        }
      }
    }
    yield put(
      atendimentoActions.setInfosProduto(
        produtosDisponiveis,
        'produtosDisponiveis',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosProduto(
        produtosSelecionados,
        'produtosSelecionados',
        index
      )
    )
    clearNotifications(index)
    if (
      response?.data?.messages?.length > 0 ||
      response?.data?.mensagensErro > 0
    ) {
      handlerErrorSimulationService(
        response?.data,
        index,
        'Houve um erro ao realizar o recálculo, tente novamente mais tarde.'
      )
    }
    toast.success('Recálculo realizado com sucesso!')
  } catch (error) {
    clearNotifications(index)
    handlerErrorSimulationService(
      error,
      index,
      'Houve um erro ao realizar o recálculo, tente novamente mais tarde.'
    )
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
interface RecalculoPropostaFgtsProps extends GenericProps {
  cpf: string
  valor: number
  parcelas: number
}

function* recalculoPropostaFgts({
  cpf,
  valor = 0,
  parcelas,
  index
}: RecalculoPropostaFgtsProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(cpf)
    yield call(
      atendimentoController.recalculoPropostaFgts,
      cpfFormated,
      valor,
      parcelas
    )
    const response = yield call(
      atendimentoController.getParcelaFgts,
      cpfFormated
    )

    const produtosDisponiveis = [
      ...atendimentosAbertos[index].tabProduto.produtosDisponiveis
    ]
    const produtosSelecionados = [
      ...atendimentosAbertos[index].tabProduto.produtosSelecionados
    ]

    if (response?.data?.content) {
      const produtoFgts: ProdutoSimulacao = {
        id: 'fgts',
        perfil: 1,
        quantidadeParcelas: Number(response?.data?.content?.quantidadeParcelas),
        servico: 9,
        valorTotalFinanciado: Number(response?.data?.content?.valorLiberado),
        banco: 'BMG',
        codigoFator: '',
        codigoProduto: null,
        cpf: cpfFormated,
        listProdutos: [],
        listParcelas: [],
        mensagemOperadora: null,
        matricula: '0',
        porcentagemFator: 0,
        valorSolicitado: 0,
        valorLimite: 0,
        valorParcela: 0,
        valorLiberado: 0,
        valorSaqueMaximo: 0,
        valorSaqueMinimo: 0,
        valorSaque: maskMoney(0),
        flagSaqueAutorizado: false,
        flagSaqueParcelado: false,
        flagAberturaConta: false,
        bancoSimulacaoEnum: 0,
        margemDisponivel: 0,
        margemDisponivelCartao: 0,
        margemDisponivelCartaoBeneficio: 0,
        tipoProduto: 0,
        produtosSINDNAP: undefined,
        numeroContaInterna: null,
        clienteElegivel: false,
        permiteAgregacaoRefin: false,
        valorMargem: 0,
        limiteCartao: 0,
        limiteDisponivel: 0,
        tipoSaque: 0
      }
      const indexDisponiveis = produtosDisponiveis.findIndex(
        (produto) => produto.servico === produtoFgts.servico
      )
      const indexSelecionados = produtosSelecionados.findIndex(
        (produto) => produto.servico === produtoFgts.servico
      )
      if (indexDisponiveis !== -1) {
        produtosDisponiveis[indexDisponiveis] = {
          ...produtosDisponiveis[indexDisponiveis],
          ...produtoFgts
        }
      }
      if (indexSelecionados !== -1) {
        produtosSelecionados[indexSelecionados] = {
          ...produtosSelecionados[indexSelecionados],
          ...produtoFgts
        }
      }
    }

    yield put(
      atendimentoActions.setInfosProduto(
        produtosDisponiveis,
        'produtosDisponiveis',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosProduto(
        produtosSelecionados,
        'produtosSelecionados',
        index
      )
    )
    toast.success('Recálculo realizado com sucesso!')
  } catch (error) {
    clearNotifications(index)
    handlerErrorSimulationService(
      error,
      index,
      'Houve um erro ao realizar o recálculo do FGTS, tente novamente mais tarde.'
    )
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getResumoContratacao({ cpf, index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(cpf)
    const matriculasContratacao = atendimentosAbertos[
      index
    ].tabProduto.produtosSelecionados
      .filter((produto) => produto.servico !== 13)
      .map((produto) => {
        return produto.matricula
      })
    const response = yield call(
      atendimentoController.getResumoContratacao,
      cpfFormated,
      [...new Set(matriculasContratacao)]
    )

    const infosClienteResumo: InfosClienteResumo = {
      bairro: response?.data?.content?.bairro,
      cep: response?.data?.content?.cep,
      cidade: response?.data?.content?.cidade,
      cidadeNascimento: response?.data?.content?.cidadeNascimento,
      complemento: response?.data?.content?.complemento,
      cpf: maskCPF(response?.data?.content?.cpf),
      dataEmissao: moment(response?.data?.content?.dataEmissao).format(
        'DD/MM/YYYY'
      ),
      dataNascimento: moment(response?.data?.content?.dataNascimento).format(
        'DD/MM/YYYY'
      ),
      emissorIdentidade: response?.data?.content?.emissorIdentidade,
      estadoCivil: response?.data?.content?.estadoCivil,
      grauInstrucao: response?.data?.content?.grauInstrucao,
      matriculas: response?.data?.content?.matriculas.map(
        (matricula: MatriculaResumo) => {
          return {
            id: matricula.id,
            numeroMatricula: matricula.numeroMatricula,
            tipoPerfil: matricula.tipoPerfil,
            descricaoPerfil: matricula.descricaoPerfil,
            tipoPerfilId: matricula.tipoPerfilId,
            convenioId: matricula.convenioId,
            margemDisponivel: matricula.margemDisponivel,
            margemCartaoDisponivel: matricula.margemCartaoDisponivel,
            margemCartaoBeneficio: matricula.margemCartaoBeneficio,
            descricaoBanco: matricula.descricaoBanco,
            contaCorrenteId: matricula.contaCorrenteId,
            tipoContaId: matricula.tipoContaId,
            bancoDadosBancariosId: matricula.bancoDadosBancariosId,
            numeroAgencia: matricula.numeroAgencia,
            digitoVerificadorAgencia: matricula.digitoVerificadorAgencia,
            numeroConta: matricula.numeroConta,
            digitoVerificadorConta: matricula.digitoVerificadorConta
          }
        }
      ),
      nacionalidade: response?.data?.content?.nacionalidade,
      nome: response?.data?.content?.nome,
      nomeConjuge: response?.data?.content?.nomeConjuge,
      nomeMae: response?.data?.content?.nomeMae,
      nomePai: response?.data?.content?.nomePai,
      numeroEndereco: response?.data?.content?.numeroEndereco,
      numeroIdentidade: response?.data?.content?.numeroIdentidade,
      sexo: response?.data?.content?.sexo,
      uf: response?.data?.content?.uf,
      ufIdentidade: response?.data?.content?.ufIdentidade,
      ufNascimento: response?.data?.content?.ufNascimento,
      logradouro: response?.data?.content?.logradouro,
      numero: response?.data?.content?.numero,
      ddd: response?.data?.content?.ddd,
      contaCorrentePrincipal: response?.data?.content?.contaCorrentePrincipal
    }

    yield put(
      atendimentoActions.setInfosProduto(
        infosClienteResumo,
        'infosClienteResumo',
        index
      )
    )
    if (atendimentosAbertos[index].tabContato.clienteSite) {
      yield call(atendimentoController.atualizarContatoRd, cpfFormated, {
        tags: ['etapa_resumodacontratacao_crm']
      })
    }
  } catch (error) {
    handlerError(error, 'Não foi possível carregar as informações do cliente!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getSolicitacoesIN100({ cpf }: GenericProps): SagaIterator {
  try {
    const cpfFormated = removeMaskCPF(cpf)
    yield call(atendimentoController.getSolicitacoesIN100, cpfFormated)
  } catch (error) {
    //
  }
}

function* getTelefones({ cpf, index }: GenericProps): SagaIterator {
  try {
    const cpfFormated = removeMaskCPF(cpf)
    const response = yield call(atendimentoController.getTelefones, cpfFormated)
    const telefonesFormated = response?.data?.content.map(
      (telefone: { ddd: string; numero: string }) => {
        return {
          label: maskPhoneWithDDD(telefone.ddd + telefone.numero),
          value: maskPhoneWithDDD(telefone.ddd + telefone.numero)
        }
      }
    )
    yield put(
      atendimentoActions.setInfosProduto(
        telefonesFormated,
        'telefonesClienteIN100',
        index
      )
    )
  } catch (error) {
    //
  }
}

interface InserirSolicitacaoIN100Props extends GenericProps {
  telefone: string
  matricula: string
}

function* inserirSolicitacaoIN100({
  cpf,
  telefone,
  matricula,
  index
}: InserirSolicitacaoIN100Props): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(cpf)
    yield call(
      atendimentoController.inserirSolicitacaoIN100,
      cpfFormated,
      telefone,
      matricula
    )
    const responseTelefones = yield call(
      atendimentoController.getTelefonesValidos,
      atendimentosAbertos[index].cpf
    )
    const telefones: InfosChamada['telefones'] = []
    responseTelefones?.data?.content?.forEach((telefone: Telefone) => {
      telefones.push({
        numero: maskPhoneWithDDD(telefone.ddd + telefone.numero),
        whatsapp: telefone.whatsapp,
        telefoneId: telefone.telefoneId
      })
    })
    yield put(
      atendimentoActions.setInfosContatoField(
        {
          ...atendimentosAbertos[index].tabContato.infosChamada,
          telefones: telefones
        },
        'infosChamada',
        index
      )
    )
    yield put(
      atendimentoActions.getInformacoesClienteSaga(
        atendimentosAbertos[index].cpf,
        index
      )
    )
    yield put(atendimentoActions.getDadosBancariosCadastradosSaga(index))

    toast.success('Solicitação enviada com sucesso!')
  } catch (error) {
    handlerError(error, 'Não foi possível enviar a solicitação!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface validaStatusIN100Props extends GenericProps {
  matricula: string
  indexBeneficio: number
}

function* validaStatusIN100({
  cpf,
  matricula,
  index,
  indexBeneficio
}: validaStatusIN100Props): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )

  try {
    yield put(
      atendimentoActions.setLoadingBeneficio(true, index, indexBeneficio)
    )

    const cpfFormated = removeMaskCPF(cpf)
    let success = false

    const res = yield call(
      atendimentoController.validaStatusIN100,
      cpfFormated,
      matricula
    )

    if (
      res?.data?.content?.success &&
      res?.data?.content?.message === 'IN100 atualizada com sucesso'
    ) {
      success = true
      toast.success(res?.data?.content?.message)

      yield put(
        atendimentoActions.getInformacoesClienteSaga(
          atendimentosAbertos[index].cpf,
          index
        )
      )
      yield put(atendimentoActions.getDadosBancariosCadastradosSaga(index))

      const beneficios = [...atendimentosAbertos[index].tabProduto.beneficios]
      beneficios[indexBeneficio] = {
        ...beneficios[indexBeneficio],
        dataAtualizacaoToken: res?.data?.content?.dataAtualizacaoToken,
        dataConsentimento: res?.data?.content?.dataConsentimento,
        dataRespostaIn100: res?.data?.content?.dataRespostaIn100
      }

      yield put(
        atendimentoActions.setInfosProduto(beneficios, 'beneficios', index)
      )
    } else if (res?.data?.content?.message === 'Aguardando retorno da IN100') {
      let loop = true

      do {
        yield delay(30000)

        const retryRes = yield call(
          atendimentoController.validaStatusIN100,
          cpfFormated,
          matricula
        )

        if (
          retryRes?.data?.content?.success &&
          retryRes?.data?.content?.message === 'IN100 atualizada com sucesso'
        ) {
          success = true
          loop = false
          toast.success(retryRes?.data?.content?.message)

          yield put(
            atendimentoActions.getInformacoesClienteSaga(
              atendimentosAbertos[index].cpf,
              index
            )
          )

          const beneficios = [
            ...atendimentosAbertos[index].tabProduto.beneficios
          ]
          beneficios[indexBeneficio] = {
            ...beneficios[indexBeneficio],
            dataAtualizacaoToken: retryRes?.data?.content?.dataAtualizacaoToken,
            dataConsentimento: retryRes?.data?.content?.dataConsentimento,
            dataRespostaIn100: retryRes?.data?.content?.dataRespostaIn100
          }

          yield put(
            atendimentoActions.setInfosProduto(beneficios, 'beneficios', index)
          )
        } else if (
          retryRes?.data?.content?.message !== 'Aguardando retorno da IN100'
        ) {
          toast.error(retryRes?.data?.content?.message || 'Erro inesperado')
          loop = false
        }
      } while (loop && !success)
    } else {
      toast.error(res?.data?.content?.message || 'Erro inesperado')
    }
  } catch (error) {
    handlerError(error, 'Não foi possível! Tente novamente mais tarde.')
  } finally {
    yield put(
      atendimentoActions.setLoadingBeneficio(false, index, indexBeneficio)
    )
  }
}

interface ValidacaoIN100Props extends GenericProps {
  token: string
  matricula: string
}

function* validacaoIN100({
  cpf,
  matricula,
  token
}: ValidacaoIN100Props): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(cpf)
    yield call(
      atendimentoController.validacaoIN100,
      cpfFormated,
      matricula,
      token
    )
    toast.success('Código validado com sucesso!')
  } catch (error) {
    handlerError(error, 'Não foi possível validar o código!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface ConsentimentoItauProps extends GenericProps {
  telefone: string
  matricula: string
  canal: string
}

function* consentimentoItau({
  cpf,
  telefone,
  canal,
  matricula
}: ConsentimentoItauProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(cpf)
    const response = yield call(
      atendimentoController.consentimentoItau,
      cpfFormated,
      telefone,
      canal,
      matricula
    )
    toast.success(response?.data?.content)
  } catch (error) {
    handlerError(
      error,
      'Não foi possível realizar a consulta/envio da coleta de consentimento Itaú!'
    )
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface consultaConsentimentoItauProps extends GenericProps {
  cpf: string
  matricula: string
  indexBeneficio: number
}

function* consultaConsentimentoItau({
  cpf,
  matricula,
  index,
  indexBeneficio
}: consultaConsentimentoItauProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(cpf)
    const response = yield call(
      atendimentoController.ConsultaConsentimentoItau,
      cpfFormated,
      matricula
    )
    const beneficios = [...atendimentosAbertos[index].tabProduto.beneficios]
    beneficios[indexBeneficio] = {
      ...beneficios[indexBeneficio],
      dataAtualizacaoToken: response?.data?.content?.dataAtualizacaoToken,
      dataConsentimento: response?.data?.content?.dataConsentimento,
      dataRespostaIn100: response?.data?.content?.dataRespostaIn100
    }
    toast.success(response?.data?.content)
  } catch (error) {
    handlerError(
      error,
      'Não foi possível realizar a consulta/envio da coleta de consentimento Itaú!'
    )
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getProdutosContratados({ cpf, index }: GenericProps): SagaIterator {
  try {
    const cpfFormated = removeMaskCPF(cpf)
    const response = yield call(
      atendimentoController.getProdutosContratados,
      cpfFormated
    )

    const produtosContratados: ProdutosContratados[] = []

    response?.data?.content?.forEach((produto: ProdutosContratados) => {
      produtosContratados.push({
        cpf: produto.cpf,
        nomeCliente: produto.nomeCliente,
        numeroProposta: produto.numeroProposta,
        produto: produto.produto,
        valorTotal: produto.valorTotal,
        quantidadeParcelas: produto.quantidadeParcelas,
        valorParcela: produto.valorParcela,
        valorLiberado: produto.valorTotal,
        usuarioInstituicao: produto.usuarioInstituicao,
        status: produto.status,
        banco: produto.banco,
        numeroMatricula: produto.numeroMatricula,
        id: produto.id,
        ativo: produto.ativo,
        usuario: produto.usuario,
        idUsuarioCriacao: produto.idUsuarioCriacao,
        dataCriacao: produto.dataCriacao,
        dataContratacao: produto.dataContratacao,
        usuarioAlteracao: produto.usuarioAlteracao,
        idUsuarioUltimaAlteracao: produto.idUsuarioUltimaAlteracao,
        dataUltimaAlteracao: produto.dataUltimaAlteracao
      })
    })
    yield put(
      atendimentoActions.setInfosProduto(
        produtosContratados,
        'produtosContratados',
        index
      )
    )
  } catch (error) {
    //
  }
}

function* validacaoContratacao({ cpf, index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(cpf)
    const matriculasContratacao = atendimentosAbertos[
      index
    ].tabProduto.produtosSelecionados
      .filter((produto) => produto.servico !== 13)
      .map((produto) => {
        return produto.matricula
      })

    const bancos = atendimentosAbertos[
      index
    ].tabProduto.produtosSelecionados.map(
      (produto) => produto.bancoSimulacaoEnum
    )

    const response = yield call(
      atendimentoController.validacaoContratacao,
      cpfFormated,
      [...new Set(matriculasContratacao)],
      [...new Set(bancos)]
    )

    if (!response?.data?.content?.success) {
      if (!response?.data?.content?.exibirMensagem) {
        switch (response?.data?.content?.tabAtendimentoId) {
          case 3:
            handlerError({
              message:
                'Para a contratação é necessário preencher os campos obrigatórios'
            })
            break
          case 6:
            handlerError({
              message:
                'Para a contratação é necessário preencher os dados bancários'
            })
            break
          default:
            handlerError({
              message:
                'Para a contratação é necessário preencher os campos obrigatórios'
            })
            break
        }
      } else {
        handlerError(
          {
            messages: response?.data?.content?.mensagens
          },
          'Não foi possível realizar a validação para a contratação!'
        )
      }
      yield put(
        atendimentoActions.setTabAtendimentoActive(
          response?.data?.content?.tabAtendimentoId ?? 3,
          index
        )
      )
    }

    yield put(
      atendimentoActions.setInfosProduto(
        response?.data?.content?.success,
        'modalResumoContratacao',
        index
      )
    )

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.message && !error.stack) {
      toast.warn(error.message)
      yield put(atendimentoActions.setTabAtendimentoActive(3, index))
    } else {
      handlerError(
        error,
        'Não foi possível realizar a validação para a contratação!'
      )
    }
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface InfosPortabilidade {
  cpf: string
  quantidadeParcelas: number
  valorParcela: number
  servico: number
  numeroProduto: number
  bancoSimulacaoEnum: number
  codigoBanco: string
  codigoSimulacao: number
  codigoTabelaFator: string
  flagAberturaConta: boolean
  numeroContaInterna: number | null
  numeroContrato: string
  numeroMatricula: string
  numeroProdutoRefin: number
  quantidadeParcelasAberto: number
  quantidadeParcelasOriginal: number
  saldoDevedor: number
  tipoSaque: number
  valorLiberado: number
}

interface FinalizaContratacoesProps {
  produto: ProdutoSimulacao
  codigoTabelaSelecionado?: number
  parcelasSelecionado?: number
  codigoSimulacao?: number
  infosPortabilidade?: InfosPortabilidade
  infosCrefaz?: InfosCrefazContratacao
}

function* finalizacaoContratacao({ cpf, index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  yield put(loadingActions.setLoading(true))
  const cpfFormated = removeMaskCPF(cpf)
  function* finalizaContratacoes({
    produto,
    codigoTabelaSelecionado,
    parcelasSelecionado,
    codigoSimulacao,
    infosPortabilidade,
    infosCrefaz
  }: FinalizaContratacoesProps): Generator<
    CallEffect,
    void,
    AxiosResponse<ResponseWithMessages<ProdutoSimulacao[] | ReqFgts<null>>>
  > {
    try {
      switch (produto.servico) {
        case 1: {
          const response = yield call(atendimentoController.contratacaoBmg, {
            cpf: cpfFormated ?? '',
            numeroMatricula: produto?.matricula ?? '',
            quantidadeParcelas: produto?.quantidadeParcelas ?? 0,
            valorParcela: produto?.valorParcela ?? 0,
            servico: produto?.servico ?? 1,
            numeroProduto: produto?.codigoProduto ?? 0,
            bancoSimulacaoEnum: produto?.bancoSimulacaoEnum ?? 0,
            codigoFormaEnvioTermo: produto?.codigoFormaEnvioTermo ?? '',
            valorLiberado: produto?.valorSolicitado ?? 0, // Enviando valor cheio na contratação do empréstimo
            capitalSegurado: produto?.flagSeguroPrestamista
              ? produto.seguroPrestamistaEmprestimo?.capitalSegurado
              : null,
            valorDoSeguro: produto?.flagSeguroPrestamista
              ? produto.seguroPrestamistaEmprestimo?.valorSeguro
              : null
          })

          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 2: {
          if (!codigoTabelaSelecionado || !parcelasSelecionado) return
          const response = yield call(
            atendimentoController.finalizacaoContratacaoCrm,
            {
              cpf: cpfFormated,
              flagSaqueAutorizado: false,
              flagSaqueParcelado: false,
              flagAberturaConta: false,
              quantidadeParcelas: parcelasSelecionado,
              valorParcela: produto.valorParcela,
              valorLiberado: produto.valorTotalFinanciado,
              finalidadeCredito: 1,
              servico: 1,
              numeroProduto: codigoTabelaSelecionado || 0,
              numeroMatricula: produto.matricula,
              codigoSimulacao: codigoSimulacao || 0,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum,
              flagRefin: true,
              tipoSaque: produto.tipoSaque
            }
          )

          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 3: {
          const response = yield call(
            atendimentoController.contratacaoPortabilidade,
            {
              cpf: cpfFormated,
              quantidadeParcelas: infosPortabilidade?.quantidadeParcelas || 0,
              valorParcela: infosPortabilidade?.valorParcela || 0,
              servico: infosPortabilidade?.servico || 0,
              numeroProduto: infosPortabilidade?.numeroProduto || 0,
              bancoSimulacaoEnum: infosPortabilidade?.bancoSimulacaoEnum || 0,
              codigoBanco: infosPortabilidade?.codigoBanco || '',
              codigoSimulacao: 0,
              codigoTabelaFator: infosPortabilidade?.codigoTabelaFator || '',
              flagAberturaConta: true,
              numeroContaInterna:
                infosPortabilidade?.numeroContaInterna || null,
              numeroContrato: infosPortabilidade?.numeroContrato || '',
              numeroMatricula: infosPortabilidade?.numeroMatricula || '',
              numeroProdutoRefin: infosPortabilidade?.numeroProdutoRefin || 0,
              quantidadeParcelasAberto:
                infosPortabilidade?.quantidadeParcelasAberto || 0,
              quantidadeParcelasOriginal:
                infosPortabilidade?.quantidadeParcelasOriginal || 0,
              saldoDevedor: infosPortabilidade?.saldoDevedor || 0,
              tipoSaque: infosPortabilidade?.tipoSaque || 0,
              valorLiberado: infosPortabilidade?.valorLiberado || 0
            }
          )

          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 5: {
          const codigoPlano = atendimentosAbertos[
            index
          ].tabProduto.listPlanoSeguroPrestamistaConsignadoSelecionadoByMatricula?.find(
            (item) => item.matricula === produto.matricula
          )?.value

          const informacoes =
            produto.planosSeguroPrestamista?.planosComLimiteSaque?.find(
              (plano) => plano.codigoPlano === codigoPlano
            )

          const response = yield call(
            atendimentoController.contratacaoSaqueCartaoBmg,
            {
              cpf: produto.cpf ?? '',
              numeroMatricula: produto.matricula,
              numeroContaInterna: produto.numeroContaInterna ?? 0,
              quantidadeParcelas: produto.quantidadeParcelas,
              valorParcela: produto.valorParcela,
              valorSaque: Number(removeMaskMoney(produto.valorSaque)) ?? 0,
              flagAberturaConta: produto.flagAberturaConta ?? false,
              servico: produto.servico ?? 5,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum,
              tipoSaque: produto.tipoSaque,
              codigoPlano: informacoes?.codigoPlano ?? 0,
              descricaoSeguro: informacoes?.nomePlano ?? '',
              capitalSegurado: informacoes?.valorCapitalSegurado ?? 0,
              valorDoSeguro: informacoes?.valorPremio ?? 0
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 6: {
          const codigoPlano = atendimentosAbertos[
            index
          ].tabProduto.listPlanoSeguroPrestamistaCartaoConsignadoSelecionadoByMatricula?.find(
            (item) => item.matricula === produto.matricula
          )?.value

          const informacoes =
            produto.planosSeguroPrestamista?.planosComLimiteSaque?.find(
              (plano) => plano.codigoPlano === codigoPlano
            )
          const response = yield call(
            atendimentoController.contratacaoCartaoCreditoConsignado,
            {
              cpf: produto.cpf,
              numeroMatricula: produto.matricula ?? '',
              valorSaque: Number(removeMaskMoney(produto.valorSaque)) ?? 0,
              servico: produto.servico ?? 6,
              flagAberturaConta: produto.flagAberturaConta ?? true,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum,
              tipoSaque: produto.tipoSaque,
              codigoPlano: informacoes?.codigoPlano ?? 0,
              descricaoSeguro: informacoes?.nomePlano ?? '',
              capitalSegurado: informacoes?.valorCapitalSegurado ?? 0,
              valorDoSeguro: informacoes?.valorPremio ?? 0,
              quantidadeParcelas: produto.quantidadeParcelas,
              valorParcela: produto.valorParcela
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 7: {
          const codigoPlano = atendimentosAbertos[
            index
          ].tabProduto.listPlanoSeguroPrestamistaCartaoBeneficioSelecionadoByMatricula?.find(
            (item) => item.matricula === produto.matricula
          )?.value

          const informacoes =
            produto.planosSeguroPrestamista?.planosComLimiteSaque?.find(
              (plano) => plano.codigoPlano === codigoPlano
            )

          const response = yield call(
            atendimentoController.contratacaoCartaoBeneficioBmg,
            {
              cpf: produto.cpf,
              numeroMatricula: produto.matricula,
              quantidadeParcelas: produto.quantidadeParcelas ?? 0,
              valorParcela: produto.valorParcela ?? 0,
              valorSaque: Number(removeMaskMoney(produto.valorSaque)) ?? 0,
              servico: produto.servico ?? 7,
              flagAberturaConta: produto.flagAberturaConta ?? true,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum ?? 0,
              tipoSaque: produto.tipoSaque ?? 0,
              codigoPlano: informacoes?.codigoPlano ?? 0,
              descricaoSeguro: informacoes?.nomePlano ?? '',
              capitalSegurado: informacoes?.valorCapitalSegurado ?? 0,
              valorDoSeguro: informacoes?.valorPremio ?? 0
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 8: {
          const codigoPlano = atendimentosAbertos[
            index
          ].tabProduto.listPlanoSeguroPrestamistaBeneficioSelecionadoByMatricula?.find(
            (item) => item.matricula === produto.matricula
          )?.value

          const informacoes =
            produto.planosSeguroPrestamista?.planosComLimiteSaque?.find(
              (plano) => plano.codigoPlano === codigoPlano
            )

          const response = yield call(
            atendimentoController.contratacaoSaqueCartaoBmg,
            {
              cpf: produto.cpf,
              numeroMatricula: produto.matricula,
              numeroContaInterna: produto.numeroContaInterna ?? 0,
              quantidadeParcelas: produto.quantidadeParcelas,
              valorParcela: produto.valorParcela,
              valorSaque: Number(removeMaskMoney(produto.valorSaque)) ?? 0,
              flagAberturaConta: produto.flagAberturaConta ?? false,
              servico: produto.servico ?? 5,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum ?? 0,
              tipoSaque: produto.tipoSaque,
              codigoPlano: informacoes?.codigoPlano ?? 0,
              descricaoSeguro: informacoes?.nomePlano ?? '',
              capitalSegurado: informacoes?.valorCapitalSegurado ?? 0,
              valorDoSeguro: informacoes?.valorPremio ?? 0
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 12: {
          const response = yield call(
            atendimentoController.contratatacaoSidnapiBmg,
            {
              cpf: cpfFormated ?? '',
              numeroMatricula: produto.matricula ?? '',
              servico: produto.servico ?? 12,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum ?? 0,
              valorParcela:
                produto.produtosSINDNAP?.planos[0].valorPremioAux ?? 0
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 13: {
          const response = yield call(
            atendimentoController.finalizacaoContratacaCrefazCrm,
            {
              cpf: infosCrefaz?.cpf ?? '',
              servico: infosCrefaz?.servico ?? 13,
              propostaId: infosCrefaz?.propostaId ?? 0,
              tabelaJurosId: infosCrefaz?.tabelaJurosId ?? 0,
              valorSolicitado: infosCrefaz?.valorSolicitado ?? 0,
              valorParcela: infosCrefaz?.valorParcela ?? 0,
              quantidadeParcelas: infosCrefaz?.quantidadeParcelas ?? 0,
              vencimento: infosCrefaz?.vencimento ?? '',
              produtoId: infosCrefaz?.produtoId ?? 0,
              convenioId: infosCrefaz?.convenioId ?? 0,
              convenioDados: infosCrefaz?.convenioDados ?? [],
              rendaPresumida: infosCrefaz?.rendaPresumida ?? 0
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 9: {
          yield call(
            atendimentoController.finalizacaoContratacaoFgts,
            cpfFormated
          )
          toast.success('Contratação FGTS finalizada com sucesso!')
          break
        }
        default: {
          const response = yield call(
            atendimentoController.finalizacaoContratacaoCrm,
            {
              cpf: cpfFormated,
              flagSaqueAutorizado: false,
              flagSaqueParcelado: false,
              flagAberturaConta: false,
              quantidadeParcelas: produto.quantidadeParcelas,
              valorParcela: produto.valorParcela,
              finalidadeCredito: 1,
              servico: produto.servico,
              numeroProduto: produto.codigoProduto || 0,
              numeroMatricula: produto.matricula,
              codigoSimulacao: produto.codigoSimulacao || 0,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum,
              tipoSaque: produto.tipoSaque,
              valorLiberado: produto.valorTotalFinanciado
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
        }
      }
    } catch (error) {
      if (produto.servico !== 9) {
        handlerError(error, 'Não foi possível realizar a contratação!')
      } else {
        handlerErrorFgts(
          error,
          'Não foi possível realizar a contratação do FGTS!'
        )
      }
    }
  }

  yield all(
    atendimentosAbertos[index].tabProduto.produtosSelecionados?.flatMap(
      (produto) => {
        if (produto.servico === 2) {
          const codigoTabelaSelecionado = atendimentosAbertos[
            index
          ].tabProduto.listCodigoTabelaSelectedByCodigoSimulacao?.find(
            (item) => item.id === produto.codigoSimulacao
          )?.value
          const parcelasSelecionado = atendimentosAbertos[
            index
          ].tabProduto.listParcelasSelectedByCodigoSimulacao?.find(
            (item) => item.id === produto.codigoSimulacao
          )?.value

          const indexCodigoTabelaSelected = produto.listProdutos.findIndex(
            (p) => p.codigo === codigoTabelaSelecionado
          )
          const indexParcelasSelected = produto.listProdutos[
            indexCodigoTabelaSelected
          ].listParcelas.findIndex((i) => i.parcelas === parcelasSelecionado)

          const codigoSimulacao =
            produto.listProdutos[indexCodigoTabelaSelected].listParcelas[
              indexParcelasSelected
            ].codigoSimulacao

          return [
            call(finalizaContratacoes, {
              produto,
              codigoTabelaSelecionado,
              parcelasSelecionado,
              codigoSimulacao
            })
          ]
        }
        if (produto.servico === 3) {
          const contratosElegiveis =
            produto.contratosPortabilidade?.filter(
              (contratoPortabilidade) => contratoPortabilidade.clienteElegivel
            ) || []
          return contratosElegiveis.map((contratoPortabilidade) => {
            const portabilidade =
              contratoPortabilidade.listProdutosPortabilidade.find(
                (produtoPortabilidade) => produtoPortabilidade.selecionado
              )
            return call(finalizaContratacoes, {
              produto,
              infosPortabilidade: {
                cpf: produto.cpf,
                quantidadeParcelas:
                  portabilidade?.produtosAssociados?.find(
                    (produtoAssociado) => produtoAssociado.selecionado
                  )?.listParcelas[0] || 0,
                valorParcela:
                  portabilidade?.produtosAssociados?.find(
                    (produtoAssociado) => produtoAssociado.selecionado
                  )?.valorParcela || 0,
                servico: produto.servico || 3,
                numeroProduto: portabilidade?.codigo || 0,
                bancoSimulacaoEnum: portabilidade?.banco || 0,
                codigoBanco: contratoPortabilidade.codigoBanco,
                codigoSimulacao: 0,
                codigoTabelaFator:
                  portabilidade?.produtosAssociados?.find(
                    (produtoAssociado) => produtoAssociado.selecionado
                  )?.codigoTabelaFator ?? '',
                flagAberturaConta: true,
                numeroContaInterna: produto.numeroContaInterna || 0,
                numeroContrato: contratoPortabilidade.numeroProposta || '',
                numeroMatricula: produto.matricula,
                numeroProdutoRefin:
                  portabilidade?.produtosAssociados?.find(
                    (produtoAssociado) => produtoAssociado.selecionado
                  )?.codigo || 0,
                quantidadeParcelasAberto:
                  contratoPortabilidade.quantidadeParcelaEmAberto || 0,
                quantidadeParcelasOriginal:
                  contratoPortabilidade.quantidadeTotalParcela || 0,
                saldoDevedor: contratoPortabilidade.valorSaldoDevedor || 0,
                tipoSaque: produto.tipoSaque,
                valorLiberado:
                  portabilidade?.produtosAssociados?.find(
                    (produtoAssociado) => produtoAssociado.selecionado
                  )?.valorTotalFinanciado || 0
              }
            })
          })
        }
        if (produto.servico === 13) {
          return (
            produto.simulacoesCrefaz?.map((simulacao) => {
              const convenioIndex = simulacao.empresasConveniadas.findIndex(
                (empresa) =>
                  empresa.convenioId === simulacao.selecionados.convenioId
              )
              return call(finalizaContratacoes, {
                produto,
                infosCrefaz: {
                  cpf: produto.cpf,
                  servico: produto.servico,
                  propostaId:
                    simulacao.empresasConveniadas[convenioIndex ?? 0]
                      .propostaId,
                  tabelaJurosId:
                    simulacao.empresasConveniadas[convenioIndex ?? 0]
                      .tabelaJurosId,
                  valorSolicitado: simulacao.selecionados.valorSolicitado,
                  valorParcela: simulacao.selecionados.valorParcela ?? 0,
                  quantidadeParcelas: simulacao.selecionados.prazo ?? 0,
                  vencimento:
                    simulacao.empresasConveniadas[convenioIndex ?? 0]
                      .vencimento,
                  produtoId: simulacao.produtoId,
                  convenioId: simulacao.selecionados.convenioId,
                  convenioDados: simulacao.selecionados.convenioDados,
                  rendaPresumida: simulacao.rendaPresumida
                }
              })
            }) || []
          )
        }
        return [call(finalizaContratacoes, { produto })]
      }
    )
  )
  const valorTotalNumerico = {
    cf_site_valor_disponivel_cartao_beneficio: 0,
    cf_site_valor_disponivel_cartao_consignado: 0,
    cf_site_valor_disponivel_saque_aniversario_fgts: 0,
    cf_site_valor_disponivel_saque_cartao_beneficio: 0,
    cf_site_valor_disponivel_saque_cartao_consignado: 0,
    cf_site_valor_disponivel_crefaz: 0,
    cf_site_valor_disponivel_portabilidade: 0,
    cf_site_valor_disponivel_refin: 0,
    cf_site_valor_disponivel_emprestimo_consignado: 0
  }

  const tags = new Set<string>()

  atendimentosAbertos[index].tabProduto.produtosSelecionados?.forEach(
    (produto) => {
      const { valorTotalFinanciado, valorSaque, valorPremioAux } = (() => {
        const valorTotalFinanciado = Number(produto.valorTotalFinanciado ?? 0)
        const valorSaque = produto.valorSaque
          ? Number(removeMaskMoney(produto.valorSaque))
          : 0
        const valorPremioAux = Number(
          produto.produtosSINDNAP?.planos?.[0]?.valorPremioAux ?? 0
        )
        return { valorTotalFinanciado, valorSaque, valorPremioAux }
      })()

      switch (produto.servico) {
        case 6:
          valorTotalNumerico.cf_site_valor_disponivel_cartao_consignado +=
            valorSaque
          tags.add('contratadocomsucesso_cartao_consignado')
          break
        case 7:
          valorTotalNumerico.cf_site_valor_disponivel_cartao_beneficio +=
            valorSaque
          tags.add('contratadocomsucesso_cartao_beneficio')
          break
        case 8:
          valorTotalNumerico.cf_site_valor_disponivel_saque_cartao_beneficio +=
            valorSaque
          tags.add('contratadocomsucesso_saque_cartao_beneficio')
          break
        case 5:
          valorTotalNumerico.cf_site_valor_disponivel_saque_cartao_consignado +=
            valorSaque
          tags.add('contratadocomsucesso_saque_cartao_consignado')
          break
        case 9:
          valorTotalNumerico.cf_site_valor_disponivel_saque_aniversario_fgts +=
            valorTotalFinanciado
          tags.add('contratadocomsucesso_fgts')
          break
        case 13:
          valorTotalNumerico.cf_site_valor_disponivel_crefaz += valorPremioAux
          tags.add('contratadocomsucesso_crefaz')
          break
        case 2:
          if (produto.clienteElegivel) {
            valorTotalNumerico.cf_site_valor_disponivel_refin +=
              valorTotalFinanciado
            tags.add('contratadocomsucesso_refin')
          }
          break
        case 3:
          if (
            produto.contratosPortabilidade &&
            produto.contratosPortabilidade.length > 0
          ) {
            produto.contratosPortabilidade.forEach((contrato) => {
              contrato.listProdutosPortabilidade?.forEach(
                (prodPortabilidade) => {
                  prodPortabilidade.produtosAssociados?.forEach(
                    (prodAssociado) => {
                      valorTotalNumerico.cf_site_valor_disponivel_portabilidade +=
                        prodAssociado.valorTotalFinanciado ?? 0
                    }
                  )
                }
              )
            })
          }
          tags.add('contratadocomsucesso_portabilidade')
          break
        case 1:
          valorTotalNumerico.cf_site_valor_disponivel_emprestimo_consignado +=
            valorTotalFinanciado
          tags.add('contratadocomsucesso_emprestimo_consignado')
          break
      }
    }
  )

  const valorTotalPorProduto = Object.fromEntries(
    Object.entries(valorTotalNumerico).map(([chave, valor]) => [
      chave,
      valor > 0 ? valor.toFixed(2) : ''
    ])
  )

  const somatorioTotalProdutos = atendimentosAbertos[
    index
  ].tabProduto.produtosSelecionados
    .map((produto) => {
      if (
        produto.servico === 5 ||
        produto.servico === 6 ||
        produto.servico === 7 ||
        produto.servico === 8 ||
        produto.servico === 12
      ) {
        if (!produto.flagSaqueAutorizado && !produto.flagSaqueParcelado) {
          return 0
        } else {
          return Number(removeMaskMoney(produto.valorSaque))
        }
      } else if (produto.servico === 2 && produto.clienteElegivel) {
        const codigoTabelaSelected = atendimentosAbertos[
          index
        ].tabProduto.listCodigoTabelaSelectedByCodigoSimulacao?.find(
          (item) => item.id === produto.codigoSimulacao
        )?.value

        const parcelasSelected = atendimentosAbertos[
          index
        ].tabProduto.listParcelasSelectedByCodigoSimulacao?.find(
          (item) => item.id === produto.codigoSimulacao
        )?.value

        const indexTabelaSelected =
          produto.listProdutos?.findIndex(
            (p) => p.codigo === codigoTabelaSelected
          ) ?? 0

        const indexParcelaSelected =
          produto.listProdutos?.[indexTabelaSelected]?.listParcelas.findIndex(
            (p) => p.parcelas === parcelasSelected
          ) ?? 0

        return (
          produto.listProdutos[indexTabelaSelected]?.listParcelas[
            indexParcelaSelected
          ]?.valorLiberado ?? 0
        )
      } else if (
        produto.servico === 3 &&
        produto.contratosPortabilidade?.some(
          (contrato) => contrato.clienteElegivel
        )
      ) {
        let valorTotalFinanciado = 0
        const { contratosPortabilidade } = produto

        if (contratosPortabilidade) {
          contratosPortabilidade
            .filter((contrato) => contrato.clienteElegivel)
            .forEach((contrato) => {
              contrato.listProdutosPortabilidade
                .filter(
                  (produtoPortabilidade) => produtoPortabilidade.selecionado
                )
                .forEach((produtoPortabilidade) => {
                  valorTotalFinanciado +=
                    produtoPortabilidade.produtosAssociados
                      .filter(
                        (produtoAssociado) => produtoAssociado.selecionado
                      )
                      .reduce((acc, produtoAssociado) => {
                        return (
                          acc + (produtoAssociado.valorTotalFinanciado ?? 0)
                        )
                      }, 0)
                })
            })
        }
        return valorTotalFinanciado
      } else if (produto.servico === 13) {
        let valor = 0
        for (const simulacao of produto.simulacoesCrefaz ?? []) {
          valor += simulacao.selecionados.valorSolicitado
        }
        return valor
      } else if (produto.servico === 1) {
        return produto.seguroPrestamistaEmprestimo &&
          produto.flagSeguroPrestamista
          ? produto.valorLiberado
          : produto.valorSolicitado
      } else {
        return produto.valorTotalFinanciado
      }
    })
    .reduce((acc, curr) => acc + curr, 0)

  if (atendimentosAbertos[index].tabContato.clienteSite) {
    yield call(atendimentoController.atualizarContatoRd, cpfFormated, {
      cf_site_valor_contratado_total: String(somatorioTotalProdutos.toFixed(2)),
      tags: ['etapa_contratadocomsucesso_crm', ...Array.from(tags)],
      ...valorTotalPorProduto
    })
  }

  yield put(
    atendimentoActions.setInfosProduto(false, 'modalResumoContratacao', index)
  )
  yield put(atendimentoActions.getProdutosContratadosSaga(cpfFormated, index))
  yield put(
    atendimentoActions.getPropostasCrmSaga(
      atendimentosAbertos[index].cpf,
      index
    )
  )
  yield put(loadingActions.setLoading(false))
}

function* getDadosEndereco({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cepFormated = removeMaskCEP(
      atendimentosAbertos[index].tabInformacoes.infoCliente.cep
    )
    const response = yield call(
      atendimentoController.getDadosEndereco,
      cepFormated
    )
    yield put(
      atendimentoActions.setInformacoesField(
        response?.data?.content.localidade?.toUpperCase(),
        'cidade',
        index
      )
    )
    yield put(
      atendimentoActions.setInformacoesField(
        response?.data?.content.logradouro,
        'logradouro',
        index
      )
    )
    yield put(
      atendimentoActions.setInformacoesField(
        response?.data?.content.bairro,
        'bairro',
        index
      )
    )
    yield put(
      atendimentoActions.setInformacoesField(
        response?.data?.content.uf,
        'siglaEstado',
        index
      )
    )
  } catch (error) {
    yield put(atendimentoActions.cleanInformacoesEndereco(index))
    handlerError(error, 'Não foi possível buscar os dados de endereço!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface GetInformacoesClienteProps extends GenericProps {
  onUpdate?: boolean
}

function* getInformacoesCliente({
  cpf,
  index,
  onUpdate
}: GetInformacoesClienteProps): SagaIterator {
  try {
    const cpfFormated = removeMaskCPF(cpf)
    const response = yield call(
      atendimentoController.getInformacoesCliente,
      cpfFormated
    )

    const informacoes: InfoCliente = {
      bairro: response?.data?.content?.bairro,
      cep: maskCEP(response?.data?.content?.cep),
      cidade: response?.data?.content?.cidade,
      cidadeNascimento: response?.data?.content?.cidadeNascimento,
      nacionalidadeId: response?.data?.content?.nacionalidadeId,
      complemento: response?.data?.content?.complemento,
      cpf: maskCPF(response?.data?.content?.cpf),
      dataEmissao: response?.data?.content?.dataEmissao,
      dataNascimento: response?.data?.content?.dataNascimento,
      ddd: response?.data?.content?.ddd,
      email: response?.data?.content?.email,
      escolaridadeId: response?.data?.content?.escolaridadeId,
      estadoCivil: response?.data?.content?.estadoCivil,
      logradouro: response?.data?.content?.logradouro,
      nome: response?.data?.content?.nome,
      nomeConjuge: response?.data?.content?.nomeConjuge,
      nomeMae: response?.data?.content?.nomeMae,
      nomePai: response?.data?.content?.nomePai,
      numero: response?.data?.content?.numero,
      numeroEndereco: response?.data?.content?.numeroEndereco,
      numeroIdentidade: response?.data?.content?.numeroIdentidade,
      orgaoEmissorId: response?.data?.content?.orgaoEmissorId,
      profissaoId: response?.data?.content?.profissaoId,
      sexo: response?.data?.content?.sexo,
      siglaEstado: response?.data?.content?.siglaEstado,
      ufNascimento: response?.data?.content?.ufNascimento,
      ufOrgaoEmissor: response?.data?.content?.ufOrgaoEmissor,
      empresa: response?.data?.content?.empresa,
      tempoEmpregoId: response?.data?.content?.tempoEmpregoId,
      referencias: response?.data?.content?.referencias
    }
    yield put(atendimentoActions.getGenerosSaga(index))
    yield put(atendimentoActions.getOrgaosEmissoresSaga(index))
    yield put(atendimentoActions.getEstadosSaga(index))
    yield put(atendimentoActions.getEscolaridadesSaga(index))
    yield put(atendimentoActions.getEstadosCivisSaga(index))
    yield put(atendimentoActions.getTiposContaSaga(index))
    yield put(atendimentoActions.getBancosSaga(index))
    yield put(atendimentoActions.getPaisesSaga(index))
    yield put(atendimentoActions.getTemposEmpregoSaga(index))
    yield put(atendimentoActions.getGrausReferenciaSaga(index))
    yield put(atendimentoActions.getProfissoesSaga(index))
    const referenciasInvalids: ReferenciaInvalid[] =
      informacoes.referencias?.map(() => {
        return {
          nome: false,
          ddd: false,
          numero: false,
          grauReferenciaCrefazId: false
        }
      }) || []
    yield put(
      atendimentoActions.setInvalidsInformacoesField(
        referenciasInvalids,
        'referencias',
        index
      )
    )
    yield put(atendimentoActions.setInformacoes(informacoes, index))
    if (onUpdate) {
      yield put(atendimentoActions.getPropostasCrmSaga(cpf, index))
    }
  } catch (error) {
    //
  }
}

interface GetCidadesProps {
  type: string
  index: number
  siglaEstado?: string
}

function* getCidades({ index, siglaEstado }: GetCidadesProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    const estado =
      siglaEstado ||
      atendimentosAbertos[index].tabInformacoes.infoCliente.siglaEstado
    let cidades = []
    if (estado) {
      const response = yield call(atendimentoController.getCidades, estado)
      cidades = response?.data?.content
    }

    yield put(
      atendimentoActions.setOptionsSelectsInformacoes(cidades, 'cidade', index)
    )
  } catch (error) {
    //
  }
}

function* getCidadesNascimento({
  index,
  siglaEstado
}: GetCidadesProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    const estado =
      siglaEstado ||
      atendimentosAbertos[index].tabInformacoes.infoCliente.ufNascimento
    let cidades = []
    if (estado) {
      const response = yield call(atendimentoController.getCidades, estado)
      cidades = response?.data?.content
    }

    yield put(
      atendimentoActions.setOptionsSelectsInformacoes(
        cidades,
        'cidadeNascimento',
        index
      )
    )
  } catch (error) {
    //
  }
}

function* getGeneros({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.genero.length ===
      0
    ) {
      const response = yield call(atendimentoController.getGeneros)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'genero',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* getOrgaosEmissores({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.orgaoEmissor
        .length === 0
    ) {
      const response = yield call(atendimentoController.getOrgaosEmissores)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'orgaoEmissor',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* getEstados({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.uf.length === 0
    ) {
      const response = yield call(atendimentoController.getEstados)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'ufOrgaoEmissor',
          index
        )
      )
      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'ufNascimento',
          index
        )
      )
      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'uf',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* getEscolaridades({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.escolaridade
        .length === 0
    ) {
      const response = yield call(atendimentoController.getEscolaridades)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'escolaridade',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* getEstadosCivis({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.estadoCivil
        .length === 0
    ) {
      const response = yield call(atendimentoController.getEstadosCivis)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'estadoCivil',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* getTiposConta({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.tipoConta
        .length === 0
    ) {
      const response = yield call(atendimentoController.getTiposConta)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'tipoConta',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* salvarInformacoesCliente({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const infosCliente = {
      ...atendimentosAbertos[index].tabInformacoes.infoCliente
    }
    const infosClienteFormated: InfoCliente = {
      nome: infosCliente.nome,
      cpf: removeMaskCPF(infosCliente.cpf),
      dataNascimento: infosCliente.dataNascimento,
      nacionalidadeId: infosCliente.nacionalidadeId,
      nomePai: infosCliente.nomePai,
      nomeMae: infosCliente.nomeMae,
      numeroIdentidade: infosCliente.numeroIdentidade,
      orgaoEmissorId: infosCliente.orgaoEmissorId,
      ufOrgaoEmissor: infosCliente.ufOrgaoEmissor,
      dataEmissao: infosCliente.dataEmissao,
      ddd: infosCliente.ddd,
      numero: infosCliente.numero,
      email: infosCliente.email,
      sexo: infosCliente.sexo,
      estadoCivil: infosCliente.estadoCivil,
      cidadeNascimento: infosCliente.cidadeNascimento,
      ufNascimento: infosCliente.ufNascimento,
      escolaridadeId: infosCliente.escolaridadeId,
      cep: infosCliente.cep,
      cidade: infosCliente.cidade,
      siglaEstado: infosCliente.siglaEstado,
      logradouro: infosCliente.logradouro,
      numeroEndereco: infosCliente.numeroEndereco,
      bairro: infosCliente.bairro,
      complemento: infosCliente.complemento,
      nomeConjuge: infosCliente.nomeConjuge,
      profissaoId: infosCliente.profissaoId,
      empresa: infosCliente.empresa,
      tempoEmpregoId: infosCliente.tempoEmpregoId,
      referencias: filterReferenciasPreenchidas(infosCliente.referencias)
    }
    const response = yield call(
      atendimentoController.salvarInformacoesCliente,
      infosClienteFormated
    )
    yield put(
      atendimentoActions.setInfosContatoField(
        response?.data?.content?.nome,
        'nome',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosContatoField(
        maskDate(response?.data?.content?.dataNascimento, 'DD/MM/YYYY'),
        'dataNascimento',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosContatoField(
        response?.data?.content?.cidade,
        'cidade',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosContatoField(
        response?.data?.content?.sexo === 'M' ? 'Masculino' : 'Feminino',
        'sexo',
        index
      )
    )
    toast.success('Informações atualizadas com sucesso!')
    yield put(atendimentoActions.cleanInformacoes(index))
    yield put(
      atendimentoActions.getInformacoesClienteSaga(
        atendimentosAbertos[index].cpf,
        index
      )
    )
    const responseTelefones = yield call(
      atendimentoController.getTelefonesValidos,
      atendimentosAbertos[index].cpf
    )
    const telefones: InfosChamada['telefones'] = []
    responseTelefones?.data?.content?.forEach((telefone: Telefone) => {
      telefones.push({
        numero: `(${telefone.ddd}) ${telefone.numero}`,
        whatsapp: telefone.whatsapp,
        telefoneId: telefone.telefoneId
      })
    })
    yield put(
      atendimentoActions.setInfosContatoField(
        {
          ...atendimentosAbertos[index].tabContato.infosChamada,
          telefones: telefones
        },
        'infosChamada',
        index
      )
    )
    yield put(
      atendimentoActions.getTelefonesSaga(atendimentosAbertos[index].cpf, index)
    )
    yield put(
      atendimentoActions.setInfosProduto([], 'produtosDisponiveis', index)
    )
    yield put(
      atendimentoActions.setInfosProduto([], 'produtosSelecionados', index)
    )
    yield put(atendimentoActions.setInfosProduto([], 'beneficios', index))
    const responsePerfilCliente = yield call(
      atendimentoController.getPerfilCliente,
      atendimentosAbertos[index].cpf
    )
    const perfis: Beneficio[] = []
    responsePerfilCliente?.data?.content?.map((perfil: Beneficio) => {
      perfis.push({
        id: perfil.id,
        clientePerfil: {
          id: perfil.clientePerfil.id,
          descricao: perfil.clientePerfil.descricao,
          tipoPerfil: perfil.clientePerfil.tipoPerfil
        },
        dataAtualizacaoToken: perfil.dataAtualizacaoToken,
        dataRespostaIn100: perfil.dataRespostaIn100,
        dataConsentimento: perfil.dataConsentimento,
        numero: perfil.numero,
        numeroNit: perfil.numeroNit,
        loading: false
      })
    })
    yield put(atendimentoActions.setInfosProduto(perfis, 'beneficios', index))
    yield put(
      atendimentoActions.getPropostasCrmSaga(
        atendimentosAbertos[index].cpf,
        index
      )
    )
    if (atendimentosAbertos[index].tabContato.clienteSite) {
      yield call(atendimentoController.atualizarContatoRd, infosCliente.cpf, {
        cf_site_cpf: Number(removeMaskCPF(infosCliente.cpf)),
        name: infosCliente.nome,
        email: infosCliente.email ?? undefined,
        mobile_phone: infosCliente.ddd + infosCliente.numero,
        birthdate: infosCliente.dataNascimento,
        cf_site_genero: infosCliente.sexo,
        cf_site_estado_civil: infosCliente.estadoCivil ?? undefined,
        city: infosCliente.cidade,
        state: infosCliente.siglaEstado,
        cf_site_cep: Number(removeMaskCEP(infosCliente.cep)),
        tags: ['etapa_dadoscomplementares_crm']
      })
    }
  } catch (error) {
    handlerError(error, 'Não foi possível atualizar as informações do cliente!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getBancos({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.banco.length === 0
    ) {
      const response = yield call(atendimentoController.getBancos)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'banco',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* getPaises({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.paises.length ===
      0
    ) {
      const response = yield call(atendimentoController.getPaises)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'paises',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* getTemposEmprego({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.temposEmprego
        .length === 0
    ) {
      const response = yield call(atendimentoController.getTemposEmprego)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'temposEmprego',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* getGrausReferencia({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabInformacoes.optionsSelect.grausReferencia
        .length === 0
    ) {
      const response = yield call(atendimentoController.getGrausReferencia)

      yield put(
        atendimentoActions.setOptionsSelectsInformacoes(
          response?.data?.content,
          'grausReferencia',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

interface MatriculasProps extends GenericProps {
  indexBeneficio: number
}

function* getContratos({
  cpf,
  index,
  indexBeneficio
}: MatriculasProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    const response = yield call(
      atendimentoController.getContratos,
      cpf,
      atendimentosAbertos[index].tabMatriculas.infosMatriculas?.[indexBeneficio]
        .tabelaContratos.page,
      atendimentosAbertos[index].tabMatriculas.infosMatriculas?.[indexBeneficio]
        .tabelaContratos.pageSize,
      atendimentosAbertos[index].tabProduto.beneficios[indexBeneficio].numero
    )
    const contratos: Contratos[] = []
    response?.data?.content?.registros.forEach((contrato: Contratos) =>
      contratos.push({
        codigoBanco: contrato.codigoBanco,
        banco: contrato.banco,
        id: contrato.id,
        matricula: contrato.matricula,
        numeroContrato: contrato.numeroContrato,
        valorContrato: contrato.valorContrato,
        tipoEmprestimo: contrato.tipoEmprestimo,
        inicioContrato: contrato.inicioContrato,
        fimContrato: contrato.fimContrato,
        parcelasEmAberto: contrato.parcelasEmAberto,
        quantidadeParcelas: contrato.quantidadeParcelas,
        valorParcela: contrato.valorParcela,
        dataAverbacao: contrato.dataAverbacao,
        situacao: contrato.situacao,
        taxa: contrato.taxa,
        saldoDevedorAproximado: contrato.saldoDevedorAproximado,
        valorReservado: contrato.valorReservado
      })
    )
    yield put(
      atendimentoActions.setInfosMatriculas(
        contratos,
        'contratos',
        index,
        indexBeneficio
      )
    )
    yield put(
      atendimentoActions.setPaginationContratos(
        response?.data?.content?.quantidadeTotal,
        'totalRegistros',
        index,
        indexBeneficio
      )
    )
  } catch (error) {
    //
  }
}

function* adicionarMatricula({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    const matricula =
      atendimentosAbertos[index].tabMatriculas.modalRegisterMatricula.register
    yield put(loadingActions.setLoading(true))
    yield call(
      atendimentoController.adicionarMatricula,
      atendimentosAbertos[index].cpf,
      {
        id: matricula.id,
        numeroMatricula: matricula.numeroMatricula,
        tipoPerfil: matricula.tipoPerfil,
        descricaoPerfil: matricula.descricaoPerfil,
        tipoPerfilId: matricula.tipoPerfilId ?? '',
        convenioId: matricula.convenioId,
        margemDisponivel: Number(removeMaskMoney(matricula.margemDisponivel)),
        margemCartaoDisponivel: Number(
          removeMaskMoney(matricula.margemCartaoDisponivel)
        ),
        margemCartaoBeneficio: Number(
          removeMaskMoney(matricula.margemCartaoBeneficio)
        ),
        numeroNit: matricula.numeroNit
      }
    )
    yield put(
      atendimentoActions.setInfosModalMatriculaFields(false, 'isOpen', index)
    )
    yield put(atendimentoActions.cleanRegisterMatriculaInvalid(index))
    yield put(atendimentoActions.setInfosProduto([], 'beneficios', index))
    yield put(atendimentoActions.cleanRegisterMatricula(index))
    const responsePerfilCliente = yield call(
      atendimentoController.getPerfilCliente,
      atendimentosAbertos[index].cpf
    )
    const perfis: Beneficio[] = []
    responsePerfilCliente?.data?.content?.map((perfil: Beneficio) => {
      perfis.push({
        id: perfil.id,
        clientePerfil: {
          id: perfil.clientePerfil.id,
          descricao: perfil.clientePerfil.descricao,
          tipoPerfil: perfil.clientePerfil.tipoPerfil
        },
        dataAtualizacaoToken: perfil.dataAtualizacaoToken,
        dataRespostaIn100: perfil.dataRespostaIn100,
        dataConsentimento: perfil.dataConsentimento,
        numero: perfil.numero,
        numeroNit: perfil.numeroNit,
        loading: false
      })
    })
    yield put(atendimentoActions.setInfosProduto(perfis, 'beneficios', index))
    toast.success('Matrícula adicionada com sucesso!')
  } catch (error) {
    handlerError(error, 'Não foi possível salvar as informações de matrícula')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
function* removerMatricula({
  index,
  indexBeneficio
}: MatriculasProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    const matriculaId =
      atendimentosAbertos[index].tabMatriculas.infosMatriculas[indexBeneficio]
        .infosConsig?.idMatricula
    yield put(loadingActions.setLoading(true))
    yield call(atendimentoController.removerMatricula, matriculaId ?? '')
    yield put(atendimentoActions.setInfosProduto([], 'beneficios', index))
    const responsePerfilCliente = yield call(
      atendimentoController.getPerfilCliente,
      atendimentosAbertos[index].cpf
    )
    const perfis: Beneficio[] = []
    responsePerfilCliente?.data?.content?.map((perfil: Beneficio) => {
      perfis.push({
        id: perfil.id,
        clientePerfil: {
          id: perfil.clientePerfil.id,
          descricao: perfil.clientePerfil.descricao,
          tipoPerfil: perfil.clientePerfil.tipoPerfil
        },
        dataAtualizacaoToken: perfil.dataAtualizacaoToken,
        dataRespostaIn100: perfil.dataRespostaIn100,
        dataConsentimento: perfil.dataConsentimento,
        numero: perfil.numero,
        numeroNit: perfil.numeroNit,
        loading: false
      })
    })
    yield put(atendimentoActions.setInfosProduto(perfis, 'beneficios', index))
    yield put(atendimentoActions.getDadosBancariosCadastradosSaga(index))
    toast.success('Matrícula removida com sucesso!')
  } catch (error) {
    handlerError(error, 'Não foi possível remover as informações de matrícula')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getInfosClienteConsig({
  index,
  indexBeneficio
}: MatriculasProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    const response = yield call(
      atendimentoController.getInfosClienteConsig,
      atendimentosAbertos[index].cpf,
      atendimentosAbertos[index].tabProduto.beneficios[indexBeneficio].numero
    )
    const infosConsig: InfosConsig = {
      nome: response?.data?.content?.nome,
      idade: response?.data?.content?.idade,
      valorRenda: response?.data?.content?.valorRenda,
      margemDisponivel: response?.data?.content?.margemDisponivel,
      margemCartaoConsignado: response?.data?.content?.margemCartaoConsignado,
      margemCartaoBeneficio: response?.data?.content?.margemCartaoBeneficio,
      situacao: response?.data?.content?.situacao,
      especie: response?.data?.content?.especie,
      possuiRepresentanteLegalProcurador:
        response?.data?.content?.possuiRepresentanteLegalProcurador,
      bloqueioEmprestismo: response?.data?.content?.bloqueioEmprestismo,
      beneficioPermiteEmprestimo:
        response?.data?.content?.beneficioPermiteEmprestimo,
      pensaoAlimenticia: response?.data?.content?.pensaoAlimenticia,
      dataDespachoBeneficio: response?.data?.content?.dataDespachoBeneficio,
      idMatricula: response?.data?.content?.idMatricula,
      margemComplementar: response?.data?.content?.margemComplementar,
      convenio: response?.data?.content?.convenio
    }
    yield put(
      atendimentoActions.setInfosMatriculas(
        infosConsig,
        'infosConsig',
        index,
        indexBeneficio
      )
    )
  } catch (error) {
    console.log(error)
  }
}

function* getInformacoesSimplificadas({ cpf }: GenericProps): SagaIterator {
  const { modalCadastroCliente }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    const response = yield call(
      atendimentoController.getInformacoesSimplificadas,
      cpf
    )
    yield put(
      atendimentoActions.setInfosCadastroClienteModal({
        ...modalCadastroCliente,
        dataNascimento: maskDate(
          response?.data?.content?.dataNascimento,
          'YYYY-MM-DD'
        ),
        nome: response?.data?.content?.nome,
        ddd: response?.data?.content?.ddd,
        telefone: response?.data?.content?.telefone
      })
    )
  } catch (error) {
    handlerError(
      error,
      'Não foi possível obter as informações deste cliente pela Consignado Rápido!'
    )
  }
}

interface AdicionarNovoTelefoneProps extends GenericProps {
  telefone: string
  isWhatsApp: boolean | null
}

function* adicionarNovoTelefone({
  index,
  telefone,
  isWhatsApp
}: AdicionarNovoTelefoneProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield call(
      atendimentoController.adicionarNovoTelefone,
      atendimentosAbertos[index].cpf,
      telefone,
      isWhatsApp
    )
    const responseTelefones = yield call(
      atendimentoController.getTelefonesValidos,
      atendimentosAbertos[index].cpf
    )
    const telefones: InfosChamada['telefones'] = []
    responseTelefones?.data?.content?.forEach((telefone: Telefone) => {
      telefones.push({
        numero: maskPhoneWithDDD(telefone.ddd + telefone.numero),
        whatsapp: telefone.whatsapp,
        telefoneId: telefone.telefoneId
      })
    })
    yield put(
      atendimentoActions.setInfosContatoField(
        {
          ...atendimentosAbertos[index].tabContato.infosChamada,
          telefones: telefones
        },
        'infosChamada',
        index
      )
    )
    yield put(
      atendimentoActions.getInformacoesClienteSaga(
        atendimentosAbertos[index].cpf,
        index,
        true
      )
    )
    toast.success('Novo telefone adicionado com sucesso!')
  } catch (error) {
    handlerError(error, 'Não foi possível adicionar um novo telefone')
  }
}

function* getMatriculasModalIndicacao({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    const matriculas: string[] = []
    atendimentosAbertos[index].tabProduto.beneficios?.map(
      (content: Beneficio) => {
        matriculas.push(content.numero)
      }
    )

    yield put(
      atendimentoActions.setInfosProduto(
        matriculas,
        'matriculasModalIndicacao',
        index
      )
    )
  } catch (error) {
    handlerError(error)
    yield put(
      atendimentoActions.setInfosProduto([], 'matriculasModalIndicacao', index)
    )
  }
}

interface RecalculoSimulacaoRefinItauProps extends GenericProps {
  cpf: string
  numeroMatricula: string
  quantidadeParcelas: number
  valorParcela: number
  servico: number
  codigoProduto: number
  banco: number
  contrato: string
  valorAgregacao: number
  index: number
  id: string
  codigoSimulacao: number
  novaMargem: number
}
function* recalculoSimulacaoRefinItau({
  cpf,
  numeroMatricula,
  quantidadeParcelas,
  valorParcela,
  servico,
  codigoProduto,
  banco,
  contrato,
  valorAgregacao,
  index,
  id,
  codigoSimulacao,
  novaMargem
}: RecalculoSimulacaoRefinItauProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  const mensagemModalElegibilidade: string[] = []

  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(cpf)

    const response = yield call(
      atendimentoController.recalculoSimulacaoRefinItau,
      cpfFormated,
      numeroMatricula,
      quantidadeParcelas,
      valorParcela,
      servico,
      codigoProduto,
      banco,
      contrato,
      valorAgregacao
    )

    if (response?.data?.content?.modalInegibilidade) {
      const mensagemIndicacao = `${response.data.content.mensagemInegibilidade} - Matrícula: ${numeroMatricula}`
      mensagemModalElegibilidade.push(mensagemIndicacao)

      const mensagensInegibilidade = [
        mensagemIndicacao,
        ...atendimentosAbertos[index].tabProduto.produtosDisponiveis
          .filter(
            (produto) =>
              produto.modalInegibilidade &&
              (produto.servico === 1 || produto.servico === 2)
          )
          .map((produto) => produto.mensagemInegibilidade)
      ]
      yield put(
        atendimentoActions.setInfosProduto(
          mensagensInegibilidade,
          'mensagemInegibilidade',
          index
        )
      )

      yield put(
        atendimentoActions.setInfosProduto(true, 'modalInegibilidade', index)
      )

      return
    }

    const produtosDisponiveis = [
      ...atendimentosAbertos[index].tabProduto.produtosDisponiveis
    ]

    const produtosSelecionados = [
      ...atendimentosAbertos[index].tabProduto.produtosSelecionados
    ]

    const indexProdutoDisponivel = produtosDisponiveis.findIndex(
      (produto) => produto.id === id
    )

    const indexProdutoSelecionado = produtosSelecionados.findIndex(
      (produto) => produto.id === id
    )

    if (response?.data?.content?.erros?.length) {
      throw {
        messages: response?.data?.content?.erros
      }
    }

    const newCodigoTabelaSelected = response?.data?.content?.[0]?.codigo

    const listParcelas = response?.data?.content?.[0]?.listParcelas

    const newParcelasSelected = listParcelas?.reduce(
      (max: number, parcela: ListaParcelasEValorTotalSimulacao) => {
        return parcela.parcelas > max ? parcela.parcelas : max
      },
      listParcelas[0].parcelas
    )

    const indexCodigoTabelaSelected = atendimentosAbertos[
      index
    ].tabProduto.listCodigoTabelaSelectedByCodigoSimulacao?.findIndex(
      (item) => item.id === codigoSimulacao
    )

    const indexParcelasSelected = atendimentosAbertos[
      index
    ].tabProduto.listParcelasSelectedByCodigoSimulacao?.findIndex(
      (item) => item.id === codigoSimulacao
    )

    const listCodigoTabelaSelectedByCodigoSimulacao = [
      ...atendimentosAbertos[index].tabProduto
        .listCodigoTabelaSelectedByCodigoSimulacao
    ]

    listCodigoTabelaSelectedByCodigoSimulacao[indexCodigoTabelaSelected] = {
      id: response.data.content.codigoSimulacao,
      value: newCodigoTabelaSelected
    }

    const listParcelasSelectedByCodigoSimulacao = [
      ...atendimentosAbertos[index].tabProduto
        .listParcelasSelectedByCodigoSimulacao
    ]

    listParcelasSelectedByCodigoSimulacao[indexParcelasSelected] = {
      id: response.data.content.codigoSimulacao,
      value: newParcelasSelected
    }

    yield put(
      atendimentoActions.setInfosProduto(
        listCodigoTabelaSelectedByCodigoSimulacao,
        'listCodigoTabelaSelectedByCodigoSimulacao',
        index
      )
    )

    yield put(
      atendimentoActions.setInfosProduto(
        listParcelasSelectedByCodigoSimulacao,
        'listParcelasSelectedByCodigoSimulacao',
        index
      )
    )

    if (indexProdutoDisponivel !== -1) {
      produtosDisponiveis[indexProdutoDisponivel] = response.data.content

      yield put(
        atendimentoActions.setInfosProduto(
          produtosDisponiveis,
          'produtosDisponiveis',
          index
        )
      )
    }

    if (indexProdutoSelecionado !== -1) {
      produtosSelecionados[indexProdutoSelecionado] = response.data.content

      yield put(
        atendimentoActions.setInfosProduto(
          produtosSelecionados,
          'produtosSelecionados',
          index
        )
      )
    }

    const margemDisponivelByMatricula =
      atendimentosAbertos[index].tabProduto.margemDisponivelByMatricula

    const indexMargemDisponivelByMatricula =
      margemDisponivelByMatricula.findIndex(
        (item) => item.matricula === numeroMatricula
      )

    margemDisponivelByMatricula[indexMargemDisponivelByMatricula] = {
      matricula: numeroMatricula,
      value: novaMargem
    }

    yield put(
      atendimentoActions.setInfosProduto(
        margemDisponivelByMatricula,
        'margemDisponivelByMatricula',
        index
      )
    )

    clearNotifications(index)
    if (
      response?.data?.messages?.length > 0 ||
      response?.data?.mensagensErro > 0
    ) {
      handlerErrorSimulationService(
        response?.data,
        index,
        'Houve um erro ao realizar o recálculo, tente novamente mais tarde.'
      )
    }

    toast.success('Recálculo realizado com sucesso!')
  } catch (error) {
    clearNotifications(index)
    handlerErrorSimulationService(
      error,
      index,
      'Houve um erro ao realizar o recálculo, tente novamente mais tarde.'
    )
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface RecalculoCrefazProps extends GenericProps {
  produtoIndex: number
  convenioIndex: number
}

function* recalculoCrefaz({
  produtoIndex,
  convenioIndex,
  index
}: RecalculoCrefazProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const produtoCrefaz = atendimentosAbertos[
      index
    ].tabProduto.produtosDisponiveis.find((produto) => produto.servico === 13)
    const response = yield call(
      atendimentoController.recalculoCrefaz,
      atendimentosAbertos[index].cpf,
      produtoCrefaz?.simulacoesCrefaz?.[produtoIndex].empresasConveniadas[
        convenioIndex
      ].propostaId ?? 0,
      produtoCrefaz?.simulacoesCrefaz?.[produtoIndex].selecionados
        .valorSolicitado ?? 0,
      produtoCrefaz?.simulacoesCrefaz?.[produtoIndex].selecionados
        .convenioDados ?? []
    )
    const produtosDisponiveis = [
      ...atendimentosAbertos[index].tabProduto.produtosDisponiveis
    ]
    const produtosSelecionados = [
      ...atendimentosAbertos[index].tabProduto.produtosSelecionados
    ]
    const indexDisponiveis = produtosDisponiveis.findIndex(
      (produto) => produto.servico === 13
    )
    const indexSelecionados = produtosSelecionados.findIndex(
      (produto) => produto.servico === 13
    )
    if (indexDisponiveis !== -1) {
      produtosDisponiveis[indexDisponiveis] = {
        ...produtosDisponiveis[indexDisponiveis],
        simulacoesCrefaz: produtosDisponiveis[
          indexDisponiveis
        ]?.simulacoesCrefaz?.map((simulacao, index) => {
          if (index === produtoIndex) {
            const listaValoresLiberados: ListaValoresLiberado[] =
              response?.data?.content?.valoresLiberados
            const maiorValorLiberado = listaValoresLiberados?.reduce(
              (max, item) => {
                return item.valor > max.valor ? item : max
              },
              listaValoresLiberados?.[0]
            )

            const maiorPrazo = maiorValorLiberado.listaParcelas?.reduce(
              (max, item) => {
                return item.prazo > max.prazo ? item : max
              },
              maiorValorLiberado.listaParcelas[0]
            )
            return {
              ...simulacao,
              selecionados: {
                ...simulacao.selecionados,
                prazo: maiorPrazo?.prazo ?? null,
                valorParcela: maiorPrazo?.valor ?? null,
                valorSolicitado: maiorValorLiberado?.valor ?? 0
              },
              empresasConveniadas: simulacao.empresasConveniadas.map(
                (empresaConveniada, i) => {
                  if (convenioIndex === i) {
                    return {
                      ...empresaConveniada,
                      listaValoresLiberados:
                        response?.data?.content?.valoresLiberados
                    }
                  }
                  return empresaConveniada
                }
              )
            }
          }
          return simulacao
        })
      }
    }
    if (indexSelecionados !== -1) {
      produtosSelecionados[indexSelecionados] = {
        ...produtosSelecionados[indexSelecionados],
        simulacoesCrefaz: produtosSelecionados[
          indexSelecionados
        ]?.simulacoesCrefaz?.map((simulacao, index) => {
          if (index === produtoIndex) {
            const listaValoresLiberados: ListaValoresLiberado[] =
              response?.data?.content?.valoresLiberados
            const maiorValorLiberado = listaValoresLiberados?.reduce(
              (max, item) => {
                return item.valor > max.valor ? item : max
              },
              listaValoresLiberados?.[0]
            )

            const maiorPrazo = maiorValorLiberado.listaParcelas?.reduce(
              (max, item) => {
                return item.prazo > max.prazo ? item : max
              },
              maiorValorLiberado.listaParcelas[0]
            )
            return {
              ...simulacao,
              selecionados: {
                ...simulacao.selecionados,
                prazo: maiorPrazo?.prazo ?? null,
                valorParcela: maiorPrazo?.valor ?? null,
                valorSolicitado: maiorValorLiberado?.valor ?? 0
              },
              empresasConveniadas: simulacao.empresasConveniadas.map(
                (empresaConveniada, i) => {
                  if (convenioIndex === i) {
                    return {
                      ...empresaConveniada,
                      listaValoresLiberados:
                        response?.data?.content?.valoresLiberados
                    }
                  }
                  return empresaConveniada
                }
              )
            }
          }
          return simulacao
        })
      }
    }
    yield put(
      atendimentoActions.setInfosProduto(
        produtosDisponiveis,
        'produtosDisponiveis',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosProduto(
        produtosSelecionados,
        'produtosSelecionados',
        index
      )
    )
  } catch (error) {
    clearNotifications(index)
    handlerErrorSimulationService(
      error,
      index,
      'Houve um erro ao realizar o recálculo, tente novamente mais tarde.'
    )
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* verificaNaoPerturbe({ cpf }: GenericProps): SagaIterator {
  try {
    const cpfFormatted = removeMaskCPF(cpf)
    yield call(atendimentoController.verificaNaoPerturbe, cpfFormatted)
  } catch (error) {
    handlerError(error)
  }
}

interface GetInformacoesLeadProps extends GenericProps {
  matriculas: string[]
}

function* getInformacoesLead({
  cpf,
  matriculas,
  index
}: GetInformacoesLeadProps): SagaIterator {
  try {
    const cpfFormatted = removeMaskCPF(cpf)

    const responses: AxiosResponse<ReqCrm<InfosMatriculaLead>>[] = yield all(
      matriculas.map((matricula) =>
        call(atendimentoController.getInformacoesLead, cpfFormatted, matricula)
      )
    )

    const infosLead: InfosMatriculaLead[] = responses
      .filter(
        (response) =>
          !!response?.data?.content && !!response?.data?.content?.matricula
      )
      .map((response) => response.data.content)
    yield put(
      atendimentoActions.setInfosChamadaContato(
        infosLead,
        'infosMatriculasLead',
        index
      )
    )
  } catch (error) {
    handlerError(error)
  }
}

function* getIntegracao({ index }: GenericProps): SagaIterator {
  try {
    const response = yield call(atendimentoController.getIntegracao)
    let integracao: ParametroIntegracao = {
      url: '',
      tipoIntegracao: null
    }
    Object.keys(response?.data?.content).forEach((key) => {
      if (response?.data?.content[key] !== null) {
        integracao = {
          url: response?.data?.content[key],
          tipoIntegracao: key as keyof ParametroIntegracao['tipoIntegracao']
        }
      }
    })
    yield put(atendimentoActions.setIntegracao(integracao, index))
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    yield put(
      atendimentoActions.setMensagemErroIntegracao(error?.message ?? '', index)
    )
  }
}

function* getTiposArquivoCrefaz({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (atendimentosAbertos[index].tabUpload.tiposArquivo.length === 0) {
      const response = yield call(atendimentoController.getTiposArquivoCrefaz)
      yield put(
        atendimentoActions.setInfosUploadField(
          response?.data?.content,
          'tiposArquivo',
          index
        )
      )
    }
  } catch (error) {
    //
  }
}

function* salvarAnexo({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(atendimentoController.salvarAnexo, {
      cpf: atendimentosAbertos[index].cpf,
      arquivo: atendimentosAbertos[index].tabUpload.register.uploadedFile,
      tipoArquivoCrefazId:
        atendimentosAbertos[index].tabUpload.register.tipoArquivo
    })
    yield put(
      atendimentoActions.setInfosUploadField(
        {
          tipoArquivo: '',
          uploadedFile: null
        },
        'register',
        index
      )
    )
    yield put(atendimentoActions.getAnexosSaga(index))
    toast.success('Arquivo salvo com sucesso!')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface AnexoProps extends GenericProps {
  nomeArquivo: string
}

function* visualizarAnexo({ index, nomeArquivo }: AnexoProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(atendimentoController.downloadAnexo, {
      cpf: atendimentosAbertos[index].cpf,
      nomeArquivo
    })

    const base64Content = response?.data?.content

    if (base64Content) {
      const byteCharacters = atob(base64Content)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)

      let mimeType = 'application/octet-stream'
      if (nomeArquivo.endsWith('.pdf')) {
        mimeType = 'application/pdf'
      } else if (nomeArquivo.endsWith('.png')) {
        mimeType = 'image/png'
      } else if (
        nomeArquivo.endsWith('.jpg') ||
        nomeArquivo.endsWith('.jpeg')
      ) {
        mimeType = 'image/jpeg'
      }

      const blob = new Blob([byteArray], { type: mimeType })

      const url = window.URL.createObjectURL(blob)
      window.open(url, '_blank')
    } else {
      throw new Error('Erro ao baixar conteúdo do arquivo.')
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* downloadAnexo({ index, nomeArquivo }: AnexoProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(atendimentoController.downloadAnexo, {
      cpf: atendimentosAbertos[index].cpf,
      nomeArquivo
    })

    const base64Content = response?.data?.content

    if (base64Content) {
      const byteCharacters = atob(base64Content)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/octet-stream' })

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', nomeArquivo)
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.URL.revokeObjectURL(url)
    } else {
      throw new Error('Erro ao baixar conteúdo do arquivo.')
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* deletarAnexo({ index, nomeArquivo }: AnexoProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(atendimentoController.deletarAnexo, {
      cpf: atendimentosAbertos[index].cpf,
      nomeArquivo
    })
    yield put(atendimentoActions.getAnexosSaga(index))
    toast.success('Arquivo deletado com sucesso!')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getAnexos({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(atendimentoController.getAnexos, {
      cpf: atendimentosAbertos[index].cpf,
      pagina: atendimentosAbertos[index].tabUpload.paginacaoAnexos.page,
      registros: atendimentosAbertos[index].tabUpload.paginacaoAnexos.pageSize
    })
    yield put(
      atendimentoActions.setInfosUploadField(
        response?.data?.content?.registros.map(
          (registro: Omit<Anexo, 'index'>) => {
            return {
              ...registro,
              index
            }
          }
        ),
        'anexos',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosUploadField(
        {
          ...atendimentosAbertos[index].tabUpload.paginacaoAnexos,
          totalRegistros: response?.data?.content?.quantidadeTotal
        },
        'paginacaoAnexos',
        index
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getTiposContaDadosBancarios({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabDadosBancarios.optionsSelect.tiposConta
        .length === 0
    ) {
      const response = yield call(atendimentoController.getTiposConta)
      yield put(
        atendimentoActions.setInfosDadosBancariosField(
          response?.data?.content,
          'optionsSelect',
          index,
          'tiposConta'
        )
      )
    }
  } catch (error) {
    handlerError(error)
  }
}

function* getBancosDadosBancarios({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabDadosBancarios.optionsSelect.bancos
        .length === 0
    ) {
      const response = yield call(atendimentoController.getBancos)
      yield put(
        atendimentoActions.setInfosDadosBancariosField(
          response?.data?.content,
          'optionsSelect',
          index,
          'bancos'
        )
      )
    }
  } catch (error) {
    handlerError(error)
  }
}

function* getMatriculasDadosBancarios({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(
      atendimentoActions.setInfosDadosBancariosField(
        atendimentosAbertos[index].tabProduto.beneficios,
        'optionsSelect',
        index,
        'matriculas'
      )
    )
  } catch (error) {
    handlerError(error)
  }
}

function* getTiposPixDadosBancarios({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    if (
      atendimentosAbertos[index].tabDadosBancarios.optionsSelect.tiposPix
        .length === 0
    ) {
      const response = yield call(atendimentoController.getTiposPix)
      yield put(
        atendimentoActions.setInfosDadosBancariosField(
          response?.data?.content,
          'optionsSelect',
          index,
          'tiposPix'
        )
      )
    }
  } catch (error) {
    handlerError(error)
  }
}

function* getDadosBancariosCadastrados({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const formatedCpf = removeMaskCPF(atendimentosAbertos[index].cpf)
    const response = yield call(
      atendimentoController.getDadosBancariosCadastrados,
      formatedCpf
    )
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const convertToNumberOrNull = (value: any): number | null => {
      return value || value === '0' ? Number(value) : null
    }
    const dados = response?.data?.content?.map((dado: DadosBancarios) => {
      return {
        ...dado,
        index,
        numeroAgencia: convertToNumberOrNull(dado.numeroAgencia),
        digitoAgencia: convertToNumberOrNull(dado.digitoAgencia),
        numeroConta: convertToNumberOrNull(dado.numeroConta),
        digitoConta: convertToNumberOrNull(dado.digitoConta),
        id: generateGuid()
      }
    })
    yield put(
      atendimentoActions.setInfosDadosBancariosField(
        dados,
        'dadosBancariosCadastrados',
        index
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* salvarDadosBancarios({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const formatedCpf = removeMaskCPF(atendimentosAbertos[index].cpf)
    yield call(atendimentoController.salvarDadosBancarios, {
      cpf: formatedCpf,
      contaCorrenteId:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios
          .contaCorrenteId,
      numeroAgencia:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios
          .numeroAgencia,
      digitoAgencia:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios
          .digitoAgencia,
      numeroConta:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios.numeroConta,
      digitoConta:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios.digitoConta,
      chavePix:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios.chavePix,
      tipoPixId:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios.tipoPixId,
      tipoContaId:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios.tipoContaId,
      bancoDadosBancarioId:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios
          .bancoDadosBancariosId,
      matriculaId:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios.matriculaId,
      principal:
        atendimentosAbertos[index].tabDadosBancarios.dadosBancarios.principal
    })
    yield put(atendimentoActions.cleanDadosBancarios(index))
    yield put(atendimentoActions.getDadosBancariosCadastradosSaga(index))
    toast.success('Dados bancários salvos com sucesso!')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface VisualizarDadosBancariosProps extends GenericProps {
  id: string
}

function* visualizarDadosBancarios({
  id,
  index
}: VisualizarDadosBancariosProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(atendimentoController.getDadoBancario, id)
    const dados = {
      contaCorrenteId: response?.data?.content?.contaCorrenteId,
      numeroAgencia: response?.data?.content?.numeroAgencia,
      digitoAgencia: response?.data?.content?.digitoAgencia,
      numeroConta: response?.data?.content?.numeroConta,
      digitoConta: response?.data?.content?.digitoConta,
      chavePix: response?.data?.content?.chavePix,
      tipoPixId: response?.data?.content?.tipoPixId,
      tipoContaId: response?.data?.content?.tipoContaId,
      bancoDadosBancariosId: response?.data?.content?.bancoDadosBancarioId,
      matriculaId: response?.data?.content?.matriculaId,
      principal: response?.data?.content?.principal
    }
    yield put(
      atendimentoActions.setInfosDadosBancariosField(
        dados,
        'dadosBancarios',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosDadosBancariosField(
        response?.data?.content?.matriculaId,
        'configs',
        index,
        'matriculaId'
      )
    )
    yield put(
      atendimentoActions.setInfosDadosBancariosField(
        true,
        'configs',
        index,
        'visualizacao'
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface EditarDadosBancariosProps extends GenericProps {
  id: string
}

function* editarDadosBancarios({
  id,
  index
}: EditarDadosBancariosProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(atendimentoController.getDadoBancario, id)
    const dados = {
      contaCorrenteId: response?.data?.content?.contaCorrenteId,
      numeroAgencia: response?.data?.content?.numeroAgencia,
      digitoAgencia: response?.data?.content?.digitoAgencia,
      numeroConta: response?.data?.content?.numeroConta,
      digitoConta: response?.data?.content?.digitoConta,
      chavePix: response?.data?.content?.chavePix,
      tipoPixId: response?.data?.content?.tipoPixId,
      tipoContaId: response?.data?.content?.tipoContaId,
      bancoDadosBancariosId: response?.data?.content?.bancoDadosBancarioId,
      matriculaId: response?.data?.content?.matriculaId,
      principal: response?.data?.content?.principal
    }
    yield put(
      atendimentoActions.setInfosDadosBancariosField(
        dados,
        'dadosBancarios',
        index
      )
    )
    yield put(
      atendimentoActions.setInfosDadosBancariosField(
        response?.data?.content?.matriculaId,
        'configs',
        index,
        'matriculaId'
      )
    )
    yield put(
      atendimentoActions.setInfosDadosBancariosField(
        false,
        'configs',
        index,
        'visualizacao'
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface DeletarDadosBancariosProps extends GenericProps {
  id: string
}

function* deletarDadosBancarios({
  id,
  index
}: DeletarDadosBancariosProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    yield call(atendimentoController.deletarDadoBancario, id)
    yield put(atendimentoActions.getDadosBancariosCadastradosSaga(index))
    toast.success('Dados bancários salvos com sucesso!')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface IniciarAtendimentoDiscadorProps extends GenericProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
}

function* iniciarAtendimentoDiscador({
  data
}: IniciarAtendimentoDiscadorProps): SagaIterator {
  try {
    const cpfFormated = removeMaskCPF(
      data.agentConnectEvent.variables['PABXIP_ADDITIONALPROP1']
    )
    const campanhaCrmId =
      data.agentConnectEvent.variables['PABXIP_ADDITIONALPROP2']
    const telefone = data.agentConnectEvent.variables['DISCAGEM-NUMERO']
    const telefoneId = data.agentConnectEvent.variables['DISCAGEM-NUMERO-ID']
    const response = yield call(
      atendimentoController.iniciarAtendimentoCampanhaDiscador,
      {
        cpf: cpfFormated,
        campanhaCrmId: campanhaCrmId,
        telefoneId: telefoneId
      }
    )
    yield call(
      atendimentoController.pausarAgente,
      '17eee683-b5a4-4b82-a034-174e4f73a0b6'
    )
    yield put(navbarActions.getStatusAgenteSaga())
    yield put(atendimentoActions.setAtendimentoAtivo(response?.data?.content))
    const telefones: InfosChamada['telefones'] = []
    response?.data?.content?.telefones.forEach((telefone: Telefone) => {
      telefones.push({
        numero: `(${telefone.ddd}) ${telefone.numero}`,
        whatsapp: telefone.whatsapp,
        telefoneId: telefone.telefoneId
      })
    })
    yield put(atendimentoActions.cleanCpfAtendimento())
    yield put(atendimentoActions.startAtendimento(cpfFormated, 1))
    yield put(
      atendimentoActions.setInfosContato(
        {
          nome: response?.data?.content?.nome,
          dataNascimento: moment(
            response?.data?.content?.dataNascimento
          ).format('DD/MM/YYYY'),
          cidade: response?.data?.content?.cidade,
          sexo: response?.data?.content?.sexo,
          clienteRiber: response?.data?.content?.clienteRiber,
          infosChamada: {
            telefones: telefones,
            dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
            horarioAgendamento: moment().format('HH:mm'),
            numeroChamada: maskPhoneWithDDD(telefone),
            observacoesAgendamento: '',
            tabulacaoChamada: null,
            tipoAgendamento: '',
            emChamada: true,
            infosMatriculasLead: [],
            statusChamada: StatusChamadaEnum.atendida,
            modalDiscagem: false,
            numerosDiscados: []
          },
          atendimentoId: response?.data?.content?.atendimentoId,
          tipoProduto: response?.data?.content?.tipoProduto,
          campanhaCrmId: response?.data?.content?.campanhaCrmId,
          atendimentoAgendadoId: response?.data?.content?.atendimentoAgendadoId,
          consultorId: null,
          tipoAtendimento: '',
          integracaoUrl: '',
          clienteSite: response?.data?.content?.clienteSite
        },
        response?.data?.content?.cpfCnpj
      )
    )

    if (window.location.pathname.toLowerCase() !== '/atendimento') {
      history.push('/atendimento')
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put({ type: TYPES.INICIAR_ATENDIMENTO_DISCADOR_SUCCESS })
  }
}

function* continuarAtendimentoDiscador(): SagaIterator {
  const { atendimentoAtivo }: ATENDIMENTO = yield select(
    (state: ApplicationState) => state.atendimento
  )

  const { ramalAssociado, statusAgente }: NAVBAR = yield select(
    (state: ApplicationState) => state.navbar
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormated = removeMaskCPF(atendimentoAtivo?.cpfCnpj ?? '')
    if (ramalAssociado.associado && !statusAgente.pausado) {
      yield call(
        atendimentoController.pausarAgente,
        '17eee683-b5a4-4b82-a034-174e4f73a0b6'
      )
    }
    yield put(navbarActions.getStatusAgenteSaga())
    const telefones: InfosChamada['telefones'] = []
    atendimentoAtivo?.telefones.forEach((telefone: Telefone) => {
      telefones.push({
        numero: `(${telefone.ddd}) ${telefone.numero}`,
        whatsapp: telefone.whatsapp,
        telefoneId: telefone.telefoneId
      })
    })
    yield put(atendimentoActions.cleanCpfAtendimento())
    yield put(atendimentoActions.startAtendimento(cpfFormated, 1))
    yield put(
      atendimentoActions.setInfosContato(
        {
          nome: atendimentoAtivo?.nome,
          dataNascimento: moment(atendimentoAtivo?.dataNascimento).format(
            'DD/MM/YYYY'
          ),
          cidade: atendimentoAtivo?.cidade,
          sexo: atendimentoAtivo?.sexo,
          clienteRiber: atendimentoAtivo?.clienteRiber,
          infosChamada: {
            telefones: telefones,
            dataAgendamento: moment().add(1, 'days').format('YYYY-MM-DD'),
            horarioAgendamento: moment().format('HH:mm'),
            numeroChamada: maskPhoneWithDDD(
              `${
                (atendimentoAtivo?.telefones?.[0]?.ddd ?? '') +
                (atendimentoAtivo?.telefones?.[0]?.numero ?? '')
              }`
            ),
            observacoesAgendamento: '',
            tabulacaoChamada: null,
            tipoAgendamento: '',
            emChamada: true,
            infosMatriculasLead: [],
            statusChamada: StatusChamadaEnum.finalizada,
            modalDiscagem: false,
            numerosDiscados: []
          },
          atendimentoId: atendimentoAtivo?.atendimentoId,
          tipoProduto: atendimentoAtivo?.tipoProduto,
          campanhaCrmId: atendimentoAtivo?.campanhaCrmId,
          atendimentoAgendadoId: atendimentoAtivo?.atendimentoAgendadoId,
          consultorId: null,
          tipoAtendimento: '',
          integracaoUrl: '',
          clienteSite: atendimentoAtivo?.clienteSite
        },
        atendimentoAtivo?.cpfCnpj ?? ''
      )
    )

    if (window.location.pathname.toLowerCase() !== '/atendimento') {
      history.push('/atendimento')
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getInboxesChatWoot(): SagaIterator {
  try {
    const response = yield call(atendimentoController.getConexoesChatwoot)
    yield put(
      atendimentoActions.setInboxesChatWoot(response?.data?.content.payload)
    )
  } catch (error) {
    handlerError(error)
  }
}
function* getAgentesChatwoot(): SagaIterator {
  try {
    const response = yield call(atendimentoController.getAgentesChatwoot)
    yield put(atendimentoActions.setAgentesChatWoot(response?.data?.content))
  } catch (error) {
    handlerError(error)
  }
}
function* getAgenteSelecionadoChatWoot(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(atendimentoController.getAgenteSelecionado)

    if (response?.data?.content) {
      yield put(
        atendimentoActions.setAgenteSelecionadoChatWoot(response?.data?.content)
      )
      yield put(
        atendimentoActions.setAgenteChatwootSelected(
          response?.data?.content.agenteId
        )
      )
      yield put(
        atendimentoActions.setInboxChatwootSelected(
          response?.data?.content.inboxId
        )
      )
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface CreateContatoChatwootProps extends GenericProps {
  indexContato: number
  message: string
}

function* criarMensagemChatwoot({
  index,
  indexContato,
  message
}: CreateContatoChatwootProps): SagaIterator {
  const { atendimentosAbertos, agenteChatwootSelected, inboxChatwootSelected } =
    yield select((state: ApplicationState) => state.atendimento)
  try {
    yield put(loadingActions.setLoading(true))
    const formatedCpf = removeMaskCPF(atendimentosAbertos[index].cpf)
    const response = yield call(atendimentoController.criarMensagemChatwoot, {
      mensagem: message,
      agentId: agenteChatwootSelected,
      inboxId: inboxChatwootSelected,
      cpfCliente: formatedCpf,
      numeroTelefone: removeMaskPhone(
        atendimentosAbertos[index].tabContato.infosChamada?.telefones?.[
          indexContato
        ]?.numero ?? ''
      )
    })
    toast.success('Mensagem enviada com sucesso!')
    yield put(atendimentoActions.cleanModalChatwoot())
    if (response?.data?.content?.url) {
      window.open(response?.data?.content?.url, '_blank')
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getPipelines({ index }: GenericProps): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(atendimentoController.getPipelines)
    yield put(
      atendimentoActions.setOptionsSelectContato(
        response?.data?.content,
        'pipelines',
        index
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getEtapas({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos } = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(
      atendimentoController.getEtapas,
      atendimentosAbertos[index].tabContato.modalKanban.register.pipelineId
    )
    yield put(
      atendimentoActions.setOptionsSelectContato(
        response?.data?.content,
        'etapas',
        index
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* adicionarClienteKanban({ index }: GenericProps): SagaIterator {
  const { atendimentosAbertos } = yield select(
    (state: ApplicationState) => state.atendimento
  )
  try {
    yield put(loadingActions.setLoading(true))
    const formatedCpf = removeMaskCPF(atendimentosAbertos[index].cpf)
    yield call(atendimentoController.adicionarClienteKanban, {
      cpf: formatedCpf,
      pipelineId:
        atendimentosAbertos[index].tabContato.modalKanban.register.pipelineId,
      pipelineEtapaId:
        atendimentosAbertos[index].tabContato.modalKanban.register
          .pipelineEtapaId
    })
    yield put(atendimentoActions.setModalKanbanField(false, 'isOpen', index))
    yield put(
      atendimentoActions.setModalKanbanField(
        {
          pipelineEtapaId: '',
          pipelineId: ''
        },
        'register',
        index
      )
    )
    toast.success('Cliente adicionado ao Kanban com sucesso!')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* watchGetFormularioAtendimento30() {
  yield takeEvery(
    TYPES.GET_FORMULARIO_ATENDIMENTO_30_SAGA,
    getFormularioAtendimento30
  )
}

function* watchEnviarSms() {
  yield takeEvery(TYPES.ENVIAR_SMS_SAGA, enviarSms)
}

function* watchGetConversaSms() {
  yield takeEvery(TYPES.GET_CONVERSA_SMS_SAGA, getConversaSms)
}

function* watchSalvarFormularioAtendimento30() {
  yield takeEvery(
    TYPES.SALVAR_FORMULARIO_ATENDIMENTO_30_SAGA,
    salvarFormularioAtendimento30
  )
}

function* watchGetAtendimentos() {
  yield takeEvery(TYPES.START_ATENDIMENTO_SAGA, getAtendimentos)
}

function* watchFinalizaAgendamento() {
  yield takeEvery(TYPES.FINALIZA_AGENDAMENTO_SAGA, finalizaAgendamento)
}

function* watchEnriquecerDados() {
  yield takeEvery(TYPES.ENRIQUECER_DADOS_SAGA, enriquecerDados)
}

function* watchValidarNovoAtendimento() {
  yield takeEvery(TYPES.VALIDAR_NOVO_ATENDIMENTO_SAGA, validarNovoAtendimento)
}

function* watchGetConvenios() {
  yield takeLatest(TYPES.GET_CONVENIOS_SAGA, getConvenios)
}

function* watchGetConveniosInfo() {
  yield takeEvery(TYPES.GET_CONVENIOS_INFO_SAGA, getConveniosInfo)
}

function* watchGetPerfis() {
  yield takeLatest(TYPES.GET_PERFIS_SAGA, getPerfis)
}

function* watchGetProfissoes() {
  yield takeLatest(TYPES.GET_PROFISSOES_SAGA, getProfissoes)
}

function* watchSalvarCadastroSimplificado() {
  yield takeEvery(
    TYPES.SALVAR_CADASTRO_SIMPLIFICADO_SAGA,
    salvarCadastroSimplificado
  )
}

function* watchGetPerfilCliente() {
  yield takeLatest(TYPES.GET_PERFIL_CLIENTE_SAGA, getPerfilCliente)
}

function* watchDiscarCliente() {
  yield takeEvery(TYPES.DISCAR_CLIENTE_SAGA, discarCliente)
}

function* watchGetListaAtendimentos() {
  yield takeLatest(TYPES.GET_LISTA_ATENDIMENTOS_SAGA, getListaAtendimentos)
}

function* watchGetTabulacoes() {
  yield takeEvery(TYPES.GET_TABULACOES_SAGA, getTabulacoes)
}

function* watchGetTiposAgendamento() {
  yield takeLatest(TYPES.GET_TIPOS_ATENDIMENTO_SAGA, getTiposAgendamento)
}

function* watchTabularAtendimento() {
  yield takeEvery(TYPES.TABULAR_ATENDIMENTO_SAGA, tabularAtendimento)
}

function* watchTabularAtendimentobyCpf() {
  yield takeEvery(
    TYPES.TABULAR_ATENDIMENTO_DISPATCH_SAGA,
    tabularAtendimentobyCpf
  )
}

function* watchGetPropostasCrm() {
  yield takeEvery(TYPES.GET_PROPOSTAS_CRM_SAGA, getPropostasCrm)
}

function* watchSolicitarSimulacaoFgts() {
  yield takeEvery(TYPES.SOLICITAR_SIMULACAO_FGTS_SAGA, solicitarSimulacaoFgts)
}

function* watchGetParcelasFgts() {
  yield takeEvery(TYPES.GET_PARCELAS_FGTS_SAGA, getParcelasFgts)
}

function* watchRecalculoProposta() {
  yield takeEvery(TYPES.RECALCULO_PROPOSTA_SAGA, recalculoProposta)
}

function* watchRecalculoPropostaFgts() {
  yield takeEvery(TYPES.RECALCULO_PROPOSTA_FGTS_SAGA, recalculoPropostaFgts)
}

function* watchGetResumoContratacao() {
  yield takeEvery(TYPES.GET_RESUMO_CONTRATACAO_SAGA, getResumoContratacao)
}

function* watchGetSolicitacoesIN100() {
  yield takeEvery(TYPES.GET_SOLICITACOES_IN100_SAGA, getSolicitacoesIN100)
}

function* watchGetTelefones() {
  yield takeLatest(TYPES.GET_TELEFONES_SAGA, getTelefones)
}

function* watchInserirSolicitacaoIN100() {
  yield takeEvery(
    TYPES.INSERIR_SOLICITACOES_IN100_SAGA,
    inserirSolicitacaoIN100
  )
}

function* watchValidaStatusIN100() {
  yield takeEvery(TYPES.VALIDA_STATUS_IN100_SAGA, validaStatusIN100)
}

function* watchValidacaoIN100() {
  yield takeEvery(TYPES.VALIDACAO_IN100_SAGA, validacaoIN100)
}

function* watchConsentimentoItau() {
  yield takeEvery(TYPES.CONSENTIMENTO_ITAU_SAGA, consentimentoItau)
}
function* watchConsultaConsentimentoItau() {
  yield takeEvery(
    TYPES.CONSULTA_CONSENTIMENTO_ITAU_SAGA,
    consultaConsentimentoItau
  )
}

function* watchGetProdutosContratados() {
  yield takeEvery(TYPES.GET_PRODUTOS_CONTRATADOS_SAGA, getProdutosContratados)
}

function* watchValidacaoContratacao() {
  yield takeEvery(TYPES.VALIDACAO_CONTRATACAO_SAGA, validacaoContratacao)
}

function* watchFinalizacaoContratacao() {
  yield takeEvery(TYPES.FINALIZACAO_CONTRATACAO_SAGA, finalizacaoContratacao)
}

function* watchGetDadosEndereco() {
  yield takeEvery(TYPES.GET_DADOS_ENDERECO_SAGA, getDadosEndereco)
}

function* watchGetInformacoesCliente() {
  yield takeEvery(TYPES.GET_INFORMACOES_CLIENTE_SAGA, getInformacoesCliente)
}

function* watchGetCidades() {
  yield takeLatest(TYPES.GET_CIDADES_SAGA, getCidades)
}

function* watchGetCidadesNascimento() {
  yield takeLatest(TYPES.GET_CIDADES_NASCIMENTO_SAGA, getCidadesNascimento)
}

function* watchGetGeneros() {
  yield takeLatest(TYPES.GET_GENEROS_SAGA, getGeneros)
}

function* watchGetOrgaosEmissores() {
  yield takeLatest(TYPES.GET_ORGAOS_EMISSORES_SAGA, getOrgaosEmissores)
}

function* watchGetEstados() {
  yield takeLatest(TYPES.GET_ESTADOS_SAGA, getEstados)
}

function* watchGetEscolaridades() {
  yield takeLatest(TYPES.GET_ESCOLARIDADES_SAGA, getEscolaridades)
}

function* watchGetEstadosCivis() {
  yield takeLatest(TYPES.GET_ESTADOS_CIVIS_SAGA, getEstadosCivis)
}

function* watchGetTiposConta() {
  yield takeLatest(TYPES.GET_TIPOS_CONTA_SAGA, getTiposConta)
}

function* watchGetBancos() {
  yield takeLatest(TYPES.GET_BANCOS_SAGA, getBancos)
}

function* watchGetPaises() {
  yield takeLatest(TYPES.GET_PAISES_SAGA, getPaises)
}

function* watchGetTemposEmprego() {
  yield takeLatest(TYPES.GET_TEMPOS_EMPREGO_SAGA, getTemposEmprego)
}

function* watchGetGrausReferencia() {
  yield takeLatest(TYPES.GET_GRAUS_REFERENCIA_SAGA, getGrausReferencia)
}

function* watchSalvarInformacoesCliente() {
  yield takeEvery(
    TYPES.SALVAR_INFORMACOES_CLIENTE_SAGA,
    salvarInformacoesCliente
  )
}

function* watchGetContratos() {
  yield takeEvery(TYPES.GET_CONTRATOS_SAGA, getContratos)
}

function* watchAdicionarMatricula() {
  yield takeEvery(TYPES.ADICIONAR_MATRICULA_SAGA, adicionarMatricula)
}

function* watchRemoverMatricula() {
  yield takeEvery(TYPES.REMOVER_MATRICULA_SAGA, removerMatricula)
}

export function* watchGetInfosClienteConsig() {
  yield takeEvery(TYPES.GET_INFOS_CLIENTE_CONSIG_SAGA, getInfosClienteConsig)
}

function* watchGetInformacoesSimplificadas() {
  yield takeEvery(
    TYPES.GET_INFORMACOES_SIMPLIFICADAS_SAGA,
    getInformacoesSimplificadas
  )
}

function* watchAdicionarNovoTelefone() {
  yield takeEvery(TYPES.ADICIONAR_NOVO_TELEFONE_SAGA, adicionarNovoTelefone)
}

function* watchGetMatriculasModalIndicacao() {
  yield takeEvery(
    TYPES.GET_MATRICULAS_MODAL_INDICACAO_SAGA,
    getMatriculasModalIndicacao
  )
}

function* watchRecalculoSimulacaoRefinItau() {
  yield takeEvery(
    TYPES.RECALCULO_SIMULACAO_REFIN_ITAU_SAGA,
    recalculoSimulacaoRefinItau
  )
}

function* watchRecalculoCrefaz() {
  yield takeEvery(TYPES.RECALCULO_CREFAZ_SAGA, recalculoCrefaz)
}

function* watchVerificaNaoPerturbe() {
  yield takeEvery(TYPES.VERIFICA_NAO_PERTURBE_SAGA, verificaNaoPerturbe)
}

function* watchGetInformacoesLead() {
  yield takeEvery(TYPES.GET_INFORMACOES_LEAD_SAGA, getInformacoesLead)
}

function* watchGetIntegracao() {
  yield takeEvery(TYPES.GET_INTEGRACAO_SAGA, getIntegracao)
}

function* watchGetTiposArquivoCrefaz() {
  yield takeLatest(TYPES.GET_TIPOS_ARQUIVO_CREFAZ_SAGA, getTiposArquivoCrefaz)
}

function* watchSalvarAnexo() {
  yield takeEvery(TYPES.SALVAR_ANEXO_SAGA, salvarAnexo)
}

function* watchVisualizarAnexo() {
  yield takeEvery(TYPES.VISUALIZAR_ANEXO_SAGA_DISPATCH, visualizarAnexo)
}

function* watchDownloadAnexo() {
  yield takeEvery(TYPES.DOWNLOAD_ANEXO_SAGA_DISPATCH, downloadAnexo)
}

function* watchDeletarAnexo() {
  yield takeEvery(TYPES.DELETAR_ANEXO_SAGA_DISPATCH, deletarAnexo)
}

function* watcGetAnexos() {
  yield takeEvery(TYPES.GET_ANEXOS_SAGA, getAnexos)
}

function* watchGetTiposContaDadosBancarios() {
  yield takeLatest(
    TYPES.GET_TIPOS_CONTA_DADOS_BANCARIOS_SAGA,
    getTiposContaDadosBancarios
  )
}

function* watchGetBancosDadosBancarios() {
  yield takeEvery(
    TYPES.GET_BANCOS_DADOS_BANCARIOS_SAGA,
    getBancosDadosBancarios
  )
}

function* watchGetMatriculasDadosBancarios() {
  yield takeEvery(
    TYPES.GET_MATRICULAS_DADOS_BANCARIOS_SAGA,
    getMatriculasDadosBancarios
  )
}

function* watchGetTiposPixDadosBancarios() {
  yield takeLatest(
    TYPES.GET_TIPOS_PIX_DADOS_BANCARIOS_SAGA,
    getTiposPixDadosBancarios
  )
}

function* watchGetDadosBancariosCadastrados() {
  yield takeEvery(
    TYPES.GET_DADOS_BANCARIOS_CADASTRADOS_SAGA,
    getDadosBancariosCadastrados
  )
}

function* watchSalvarDadosBancarios() {
  yield takeEvery(TYPES.SALVAR_DADOS_BANCARIOS_SAGA, salvarDadosBancarios)
}

function* watchVisualizarDadosBancarios() {
  yield takeEvery(
    TYPES.VISUALIZAR_DADOS_BANCARIOS_SAGA_DISPATCH,
    visualizarDadosBancarios
  )
}

function* watchEditarDadosBancarios() {
  yield takeEvery(
    TYPES.EDITAR_DADOS_BANCARIOS_SAGA_DISPATCH,
    editarDadosBancarios
  )
}

function* watchDeletarDadosBancarios() {
  yield takeEvery(
    TYPES.DELETAR_DADOS_BANCARIOS_SAGA_DISPATCH,
    deletarDadosBancarios
  )
}

function* watchIniciarAtendimentoDiscador() {
  yield takeEvery(
    TYPES.INICIAR_ATENDIMENTO_DISCADOR_SAGA,
    iniciarAtendimentoDiscador
  )
}

function* watchContinuarAtendimentoDiscador() {
  yield takeEvery(
    TYPES.CONTINUAR_ATENDIMENTO_DISCADOR_SAGA,
    continuarAtendimentoDiscador
  )
}

function* watchGetAgentesChatwoot() {
  yield takeEvery(TYPES.GET_AGENTES_CHATWOOT_SAGA, getAgentesChatwoot)
}

function* watchGetInboxesChatWoot() {
  yield takeEvery(TYPES.GET_INBOXES_CHATWOOT_SAGA, getInboxesChatWoot)
}

function* watchCreateContatoChatwoot() {
  yield takeEvery(TYPES.CRIAR_MENSAGEM_CHATWOOT_SAGA, criarMensagemChatwoot)
}

function* watchGetAgenteSelecionadoChatWoot() {
  yield takeEvery(
    TYPES.GET_AGENTE_SELECIONADO_CHATWOOT_SAGA,
    getAgenteSelecionadoChatWoot
  )
}

function* watchGetPipelines() {
  yield takeEvery(TYPES.GET_PIPELINES_SAGA, getPipelines)
}

function* watchGetEtapas() {
  yield takeEvery(TYPES.GET_ETAPAS_SAGA, getEtapas)
}

function* watchAdicionarClienteKanban() {
  yield takeEvery(TYPES.ADICIONAR_CLIENTE_KANBAN_SAGA, adicionarClienteKanban)
}

function* atendimentoSaga() {
  yield all([
    fork(watchGetFormularioAtendimento30),
    fork(watchSalvarFormularioAtendimento30),
    fork(watchGetAtendimentos),
    fork(watchEnviarSms),
    fork(watchGetConversaSms),
    fork(watchFinalizaAgendamento),
    fork(watchEnriquecerDados),
    fork(watchValidarNovoAtendimento),
    fork(watchGetConvenios),
    fork(watchGetConveniosInfo),
    fork(watchGetPerfis),
    fork(watchGetProfissoes),
    fork(watchSalvarCadastroSimplificado),
    fork(watchGetPerfilCliente),
    fork(watchDiscarCliente),
    fork(watchGetListaAtendimentos),
    fork(watchGetTabulacoes),
    fork(watchGetTiposAgendamento),
    fork(watchTabularAtendimento),
    fork(watchTabularAtendimentobyCpf),
    fork(watchGetPropostasCrm),
    fork(watchSolicitarSimulacaoFgts),
    fork(watchGetParcelasFgts),
    fork(watchRecalculoProposta),
    fork(watchRecalculoPropostaFgts),
    fork(watchGetResumoContratacao),
    fork(watchGetSolicitacoesIN100),
    fork(watchGetTelefones),
    fork(watchInserirSolicitacaoIN100),
    fork(watchValidaStatusIN100),
    fork(watchValidacaoIN100),
    fork(watchConsentimentoItau),
    fork(watchGetProdutosContratados),
    fork(watchValidacaoContratacao),
    fork(watchFinalizacaoContratacao),
    fork(watchGetDadosEndereco),
    fork(watchGetInformacoesCliente),
    fork(watchGetCidades),
    fork(watchGetCidadesNascimento),
    fork(watchGetGeneros),
    fork(watchGetOrgaosEmissores),
    fork(watchGetEstados),
    fork(watchGetEscolaridades),
    fork(watchGetEstadosCivis),
    fork(watchGetTiposConta),
    fork(watchGetBancos),
    fork(watchGetPaises),
    fork(watchGetTemposEmprego),
    fork(watchGetGrausReferencia),
    fork(watchSalvarInformacoesCliente),
    fork(watchGetContratos),
    fork(watchAdicionarMatricula),
    fork(watchRemoverMatricula),
    fork(watchGetInfosClienteConsig),
    fork(watchGetInformacoesSimplificadas),
    fork(watchAdicionarNovoTelefone),
    fork(watchGetMatriculasModalIndicacao),
    fork(watchRecalculoSimulacaoRefinItau),
    fork(watchRecalculoCrefaz),
    fork(watchVerificaNaoPerturbe),
    fork(watchConsultaConsentimentoItau),
    fork(watchGetInformacoesLead),
    fork(watchGetIntegracao),
    fork(watchGetTiposArquivoCrefaz),
    fork(watchSalvarAnexo),
    fork(watchVisualizarAnexo),
    fork(watchDownloadAnexo),
    fork(watchDeletarAnexo),
    fork(watcGetAnexos),
    fork(watchGetTiposContaDadosBancarios),
    fork(watchGetBancosDadosBancarios),
    fork(watchGetMatriculasDadosBancarios),
    fork(watchGetTiposPixDadosBancarios),
    fork(watchGetDadosBancariosCadastrados),
    fork(watchSalvarDadosBancarios),
    fork(watchVisualizarDadosBancarios),
    fork(watchEditarDadosBancarios),
    fork(watchDeletarDadosBancarios),
    fork(watchIniciarAtendimentoDiscador),
    fork(watchContinuarAtendimentoDiscador),
    fork(watchGetInboxesChatWoot),
    fork(watchGetAgentesChatwoot),
    fork(watchCreateContatoChatwoot),
    fork(watchGetAgenteSelecionadoChatWoot),
    fork(watchGetPipelines),
    fork(watchGetEtapas),
    fork(watchAdicionarClienteKanban)
  ])
}

export default atendimentoSaga
